import React from "react";
import DataTable from "./../../partials/table/DataTables.js";
import { Link } from "react-router-dom";
import conf from "./../../../config.js";
import SelectJs from "./../../partials/Select.js";
import axios from "axios";
import tokenApi from "../../auth/Helpers";
import { Button, Modal, Tabs, Tab } from "react-bootstrap";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SweetAlert from "sweetalert2-react";
import swal from "sweetalert2";

import Select from "react-select";
import Skeleton from "react-loading-skeleton";
import {
  UserEditSkeleton,
  UserDetailSkeleton,
  UserPrintSkeleton,
  UserButtonLoading,
} from "../../partials/loadings/ComponentLoading.js";
import ModalDropZoneImage from "../../partials/ModalDropZoneImage";
import DeleteProgressModal from "../../partials/DeleteProgressModal";
import ExcelImportWizard from "../../partials/ExcelImportWizard";


// select style
const selectStyles = {
  control: (styles) => ({
    ...styles,
    borderRadius: "100px",
    minWidth: "100%",
  }),
};

export default class Siswa extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // url API
      url_table: `${conf.uri_backend}api/v1/user/table/SI/`,
      url_create: `${conf.uri_backend}api/v1/user/create/SI`,
      url_get_user: `${conf.uri_backend}api/v1/user/edit/SI/`,
      url_update: `${conf.uri_backend}api/v1/user/update/SI`,
      url_detail: `${conf.uri_backend}api/v1/user/edit/SI/`,
      url_token_user: `${conf.uri_backend}api/v1/user/update_token/SI`,
      url_generate_all_token: `${conf.uri_backend}api/v1/user/generate-all-token/SI`,
      url_table_token: `${conf.uri_backend}api/v1/user/table_token/SI`,
      url_print_token: `${conf.uri_backend}api/v1/user/generete_token/SI`,
      url_export_data: `${conf.uri_backend}api/v1/user/export/SI/`,
      url_import_data: `${conf.uri_backend}api/v1/user/import/SI`,
      url_save_import_data: `${conf.uri_backend}api/v1/user/import_save/SI/`,
      url_delete: `${conf.uri_backend}api/v1/user/SI/`,
      url_count_table: `${conf.uri_backend}api/v1/user/count_table/SI`,
      url_delete_m: `${conf.uri_backend}api/v1/user/user_destroy/SI/`,
      url_send_mail: `${conf.uri_backend}api/v1/user/send_mail_activation/SI`,
      url_send_wa: `${conf.uri_backend}api/v1/user/send_wa_activation/SI`,
      url_generate_activation: `${conf.uri_backend}api/v1/user/generate_activation_codes/SI`,
      url_import_activation: `${conf.uri_backend}api/v1/user/import_activation_codes/SI`,
      url_import_progress: `${conf.uri_backend}api/v1/user/import_progress/`,
      // modal show
      modal_tambah: false,
      modal_detail: false,
      modal_cetak: false,
      modal_import: false,
      modal_preview_import: false,
      modal_image: false,
      modal_generate_activation: false,
      modal_import_result: false,
      modal_excel_wizard: false, // New premium import wizard


      // var data
      user_id: "",
      nisn: "",
      nama: "",
      username: "",
      no_handphone: "",
      email: "",
      password: "",
      tahun_ajaran_create: ``,
      jenis_kelamin: "",
      tanggal_lahir: "",
      startDate: new Date(),
      tahunSekarang: new Date().getFullYear(),
      id_generate: "",
      import_file: "",
      showPasswordAdd: false,
      password_create: "",

      // for data modal
      data_print: [],
      data_detail: [],
      data_preview: [],

      // alert
      show_alert: false,
      title_alert: "",
      message_alert: "",
      icon_alert: "",

      // gender array
      jenis_kelamin_text: ["Perempuan", "Laki - laki"],

      tahun_ajaran_search: "",

      // session var
      institusi_id_select: "",
      jenjang_id_select: "",
      npsn_id_select: "",
      data_session: [],
      tahun_ajaran: null,

      mode_show: 10,
      query: "",
      simpleLoading: false,
      totalUser: "",

      queryToken: "",
      mode_show_token: 10,
      searchToken: "",

      isChecked: false,
      check_item: false,
      checkAll: false,
      loading_check: false,
      selectStatus: "",
      loading_generate_token: false,

      // Generate Activation Code modal variables
      activation_tahun_ajaran: "",
      activation_prefix: "",
      activation_jumlah_token: "",
      activation_token_sama: false,
      activation_mode: "auto", // "auto" = jumlah saja, "manual" = kode & token diisi sendiri
      activation_manual_list: [{ kode_pendaftaran: "", token: "" }],
      loading_generate_activation: false,
      loading_import_activation: false,
      activation_import_file: null,

      // Import progress
      import_progress: 0,
      import_total: 0,
      import_current: 0,
      import_success: [],
      import_failed: [],
      is_importing: false,
      import_job_id: null,
      polling_interval: null,

      // Delete progress modal state
      modal_delete_progress: false,
      delete_user_id: null,
      delete_user_name: "",
      delete_steps: [
        { name: "Menghapus relasi mata pelajaran siswa", status: "pending" },
        { name: "Menghapus relasi rombel siswa", status: "pending" },
        { name: "Menghapus relasi orang tua", status: "pending" },
        { name: "Menghapus akun SSO siswa", status: "pending" },
        { name: "Menghapus data user siswa", status: "pending" },
      ],
      delete_current_step: 0,
      delete_error: null,
      is_deleting: false,
      delete_complete: false,

      // Password UI
      showPassword: false,
      passwordStrength: "",
      passwordStrengthText: "",

      // Username validation
      userStatus: "",
      user_id_edit: null,
      usernameAvailable: null,
      usernameRecommendations: [],
      checkingUsername: false,
      usernameCheckTimeout: null,
      url_check_username: `${conf.uri_backend}api/v1/user/check-username/SI`,
    };

    // Edit Function
    this.update = this.update.bind(this);
    this.showModalEdit = this.showModalEdit.bind(this);
    this.hideModalEdit = this.hideModalEdit.bind(this);

    // Create Function
    this.showModalTambah = this.showModalTambah.bind(this);
    this.hideModalTambah = this.hideModalTambah.bind(this);
    this.nama = this.nama.bind(this);
    this.username = this.username.bind(this);
    this.no_handphone = this.no_handphone.bind(this);
    this.email = this.email.bind(this);
    this.password = this.password.bind(this);
    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
    this.checkPasswordStrength = this.checkPasswordStrength.bind(this);
    this.checkUsernameAvailability = this.checkUsernameAvailability.bind(this);
    this.selectUsernameRecommendation = this.selectUsernameRecommendation.bind(this);
    this.nisn = this.nisn.bind(this);
    this.createTahunAjaran = this.createTahunAjaran.bind(this);
    this.jenis_kelamin = this.jenis_kelamin.bind(this);
    this.tanggal_lahir = this.tanggal_lahir.bind(this);
    this.create = this.create.bind(this);

    // Delete Function
    this.delete = this.delete.bind(this);

    // Token Function
    this.generate_token = this.generate_token.bind(this);
    this.generateAllToken = this.generateAllToken.bind(this);
    this.id_generate = this.id_generate.bind(this);

    // Detail Function
    this.showModalDetail = this.showModalDetail.bind(this);
    this.hideModalDetail = this.hideModalDetail.bind(this);

    // Cetak Function
    this.showModalCetak = this.showModalCetak.bind(this);
    this.hideModalCetak = this.hideModalCetak.bind(this);
    this.printToken = this.printToken.bind(this);
    this.showTableToken = this.showTableToken.bind(this);

    // Reset Search Function
    this.resetSearch = this.resetSearch.bind(this);

    // Export Function
    this.export = this.export.bind(this);

    // Import Function
    this.showModalImport = this.showModalImport.bind(this);
    this.hideModalImport = this.hideModalImport.bind(this);
    this.import_file = this.import_file.bind(this);
    this.import = this.import.bind(this);

    // Preview Import Function
    this.showModalPrevImport = this.showModalPrevImport.bind(this);
    this.hideModalPrevImport = this.hideModalPrevImport.bind(this);
    this.simpanImport = this.simpanImport.bind(this);
    this.simpanImportQueue = this.simpanImportQueue.bind(this);
    this.showModalImportResult = this.showModalImportResult.bind(this);
    this.hideModalImportResult = this.hideModalImportResult.bind(this);
    // get option filter
    this.getTahunAjaranNow = this.getTahunAjaranNow.bind(this);

    this.filterTahunAjaran = this.filterTahunAjaran.bind(this);

    // set filter
    this.setFilter = this.setFilter.bind(this);

    this.showMode = this.showMode.bind(this);
    this.showModeToken = this.showModeToken.bind(this);

    this.showCount = this.showCount.bind(this);

    this.checkAll = this.checkAll.bind(this);
    this.unCheckAll = this.unCheckAll.bind(this);
    this.deleteMulti = this.deleteMulti.bind(this);
    this.sendMailActivation = this.sendMailActivation.bind(this);
    this.sendWAActivation = this.sendWAActivation.bind(this);


    // Generate Activation Code Functions
    this.showModalGenerateActivation = this.showModalGenerateActivation.bind(this);
    this.hideModalGenerateActivation = this.hideModalGenerateActivation.bind(this);
    this.generateActivationCodes = this.generateActivationCodes.bind(this);
    this.activationImportFile = this.activationImportFile.bind(this);
    this.importActivationCodes = this.importActivationCodes.bind(this);
    this.activationTahunAjaran = this.activationTahunAjaran.bind(this);
    this.activationPrefix = this.activationPrefix.bind(this);
    this.activationJumlahToken = this.activationJumlahToken.bind(this);
    this.activationTokenSama = this.activationTokenSama.bind(this);
    this.activationSetMode = this.activationSetMode.bind(this);
    this.activationManualChange = this.activationManualChange.bind(this);
    this.activationAddManualRow = this.activationAddManualRow.bind(this);
    this.activationRemoveManualRow = this.activationRemoveManualRow.bind(this);

    // Dropzone image
    this.showModalDropzoneImage = this.showModalDropzoneImage.bind(this);
    this.hideModalDropzoneImage = this.hideModalDropzoneImage.bind(this);
  }

  componentDidMount() {
    // get session user
    if (localStorage.getItem("token") !== null) {
      axios
        .post(`${conf.uri_backend}api/v1/auth/sso/user`, {
          token: localStorage.getItem("token"),
        })
        .then((res) => {
          this.setState({ data_session: res.data }, function () {
            axios
              .get(
                `${conf.uri_backend}api/v1/select-institusi/` +
                this.state.data_session.access_to,
                { headers: { Authorization: tokenApi } }
              )
              .then((res) => {
                this.setState(
                  {
                    institusi_id_select: res.data.id,
                    jenjang_id_select: res.data.m_struktur_jenjang_id,
                    npsn_id_select: res.data.npsn,
                  },
                  function () {
                    this.dt.fetchEntities();
                    this.showCount();
                  }
                );
                this.getTahunAjaranNow();
              });
          });
        });
    }
  }

  showCount() {
    axios
      .get(
        this.state.url_count_table +
        "?institusi=" +
        this.state.institusi_id_select +
        "&tahun_ajaran=" +
        this.state.tahun_ajaran_search,
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        this.setState({ totalUser: res.data });
      });
  }

  showMode(num) {
    this.setState({ mode_show: num }, function () {
      this.dt.resetPage(
        `&paginate=${this.state.mode_show}&query=${this.state.query}`
      );
      this.dt.loading();
    });
  }

  showModeToken(num) {
    this.setState({ mode_show_token: num }, function () {
      this.dtt.resetPage(
        `&paginate=${this.state.mode_show_token}&search=${this.state.searchToken}`
      );
      this.dtt.loading();
      this.setState({ loading_saveprint: false });
    });
  }

  getTahunAjaranNow() {
    var ta = [];
    var u = this.state.tahunSekarang + 1;
    var tahun_sekarang = this.state.tahunSekarang + 1;

    for (var i = tahun_sekarang; i >= 2005; i--) {
      u = u - 1;
      ta.push({ value: u + " / " + i, label: u + " / " + i });
    }
    this.setState({ data_tahun_ajaran: ta });
  }

  nama(e) {
    this.setState({ nama: e.target.value });
  }
  username(e) {
    this.setState({ username: e.target.value });
  }
  email(e) {
    this.setState({ email: e.target.value });
  }
  password(e) {
    const val = e.target.value;
    this.setState({ password: val });
    this.checkPasswordStrength(val);
  }

  togglePasswordVisibility() {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  }

  checkPasswordStrength(password) {
    if (!password) {
      this.setState({ passwordStrength: "", passwordStrengthText: "" });
      return;
    }
    let strength = 0;
    if (password.length >= 8) strength++;
    if (password.match(/[a-z]/) && password.match(/[A-Z]/)) strength++;
    if (password.match(/\d/)) strength++;
    if (password.match(/[^a-zA-Z\d]/)) strength++;

    let text = "";
    let color = "";

    switch (strength) {
      case 0:
      case 1:
        text = "Lemah";
        color = "text-red-500";
        break;
      case 2:
      case 3:
        text = "Sedang";
        color = "text-yellow-500";
        break;
      case 4:
        text = "Kuat";
        color = "text-green-500";
        break;
      default:
        text = "";
    }
    this.setState({ passwordStrength: color, passwordStrengthText: text });
  }

  checkUsernameAvailability(username) {
    // Clear previous timeout
    if (this.state.usernameCheckTimeout) {
      clearTimeout(this.state.usernameCheckTimeout);
    }

    if (!username || username.length < 3) {
      this.setState({
        usernameAvailable: null,
        usernameRecommendations: [],
        checkingUsername: false,
      });
      return;
    }

    // Debounce: wait 500ms before checking
    const timeout = setTimeout(() => {
      this.setState({ checkingUsername: true });

      axios
        .get(this.state.url_check_username, {
          params: {
            username: username,
            exclude_id: this.state.user_id_edit,
          },
          headers: { Authorization: tokenApi },
        })
        .then((res) => {
          this.setState({
            usernameAvailable: res.data.available,
            usernameRecommendations: res.data.recommendations || [],
            checkingUsername: false,
          });
        })
        .catch((err) => {
          console.error("Error checking username:", err);
          this.setState({
            usernameAvailable: null,
            usernameRecommendations: [],
            checkingUsername: false,
          });
        });
    }, 500);

    this.setState({ usernameCheckTimeout: timeout });
  }

  selectUsernameRecommendation(recommendation) {
    this.setState({
      username: recommendation,
      usernameAvailable: true,
      usernameRecommendations: [],
    });
  }

  nik(e) {
    this.setState({ nik: e.target.value });
  }

  createTahunAjaran(e) {
    if (e) {
      this.setState({ tahun_ajaran_create: e.value });
    } else {
      this.setState({ tahun_ajaran_create: "" });
    }
  }

  nisn(e) {
    this.setState({ nisn: e.target.value });
  }

  jenis_kelamin(e) {
    this.setState({ jenis_kelamin: e.target.value });
  }

  tanggal_lahir(e) {
    this.setState({
      tanggal_lahir: e.target.value,
      startDate: e.target.value,
    });
  }

  id_generate(e) {
    this.setState({ id_generate: e.target.value });
  }

  import_file(e) {
    this.setState({ import_file: e.target.files[0] });
  }

  no_handphone(e) {
    this.setState({ no_handphone: e.target.value });
  }

  // Edit Funtion
  showModalEdit(id) {
    this.setState({
      modal_edit: true,
      loading_edit: true,
    });

    axios
      .get(this.state.url_get_user + id, {
        headers: { Authorization: tokenApi },
      })
      .then((res) => {
        if (res.data.status == true) {
          var data = res.data.data;
          this.setState({
            id_edit: data.id,
            user_id_edit: data.user_id,
            nisn: data.kode_pendaftaran,
            nama: data.nama,
            username: data.username,
            email: data.email,
            tahun_ajaran_create: data.tahun_ajaran,
            jenis_kelamin: data.jenis_kelamin,
            tanggal_lahir: data.tanggal_lahir,
            no_handphone: data.no_handphone,
            userStatus: data.status || "",
            usernameAvailable: null,
            usernameRecommendations: [],
            loading_edit: false,
          });
        }
      });
  }

  hideModalEdit() {
    if (this.state.usernameCheckTimeout) {
      clearTimeout(this.state.usernameCheckTimeout);
    }
    this.setState({
      modal_edit: false,
      nama: "",
      nisn: "",
      jenis_kelamin: "",
      tahun_ajaran_create: "",
      tanggal_lahir: "",
      no_handphone: "",
      userStatus: "",
      user_id_edit: null,
      usernameAvailable: null,
      usernameRecommendations: [],
      checkingUsername: false,
      passwordStrength: "",
      passwordStrengthText: "",
    });
  }

  alertMessage(e) {
    let message = null;

    switch (e.status) {
      case 422:
        message = e.data.messages[0];
        break;
      case 500:
        message =
          "Ada yang Salah, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 404:
        message = "Url Not Found, Coba Hubungi Admin 😊";
        break;
      case 401:
        message =
          "Nauthorized, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 400:
        message =
          "Koneksi Buruk, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 408:
        message =
          "Request Timeout, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 429:
        message =
          "Too Many Request, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 405:
        message =
          "Method Tidak Diperbolehkan, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
    }

    this.setState({
      show_alert: true,
      title_alert: "Gagal",
      icon_alert: "error",
      message_alert: message,
      simpleLoading: false,
    });
  }

  update(event) {
    console.log("I AM HERE");

    event.preventDefault();

    // Check if username validation is in progress
    if (this.state.checkingUsername) {
      this.setState({
        show_alert: true,
        title_alert: "Mohon Tunggu",
        icon_alert: "warning",
        message_alert: "Sedang memeriksa ketersediaan username. Mohon tunggu sebentar.",
      });
      return;
    }

    // Check if username is not available
    if (this.state.usernameAvailable === false) {
      this.setState({
        show_alert: true,
        title_alert: "Username Tidak Tersedia",
        icon_alert: "error",
        message_alert: "Username yang Anda masukkan sudah digunakan oleh pengguna lain. Silakan pilih username lain dari rekomendasi yang tersedia atau masukkan username yang berbeda.",
      });
      return;
    }

    this.setState({ simpleLoading: true });

    console.log(
      "OKOKOK",
      this.state.name,
      this.state.nisn,
      this.state.jenis_kelamin,
      this.state.tanggal_lahir,
      this.state.tahun_ajaran_create,
      this.state.no_handphone,
    );

    // Validate required fields with OR (any empty field triggers error)
    if (
      this.state.nama == "" ||
      this.state.nisn == "" ||
      (this.state.jenis_kelamin === "" || this.state.jenis_kelamin === null) ||
      this.state.tanggal_lahir == "" ||
      this.state.tahun_ajaran_create == ""
    ) {
      const missingFields = [];
      if (!this.state.nama) missingFields.push("Nama Lengkap");
      if (!this.state.nisn) missingFields.push("NISN/Kode Pendaftaran");
      if (this.state.jenis_kelamin === "" || this.state.jenis_kelamin === null) missingFields.push("Jenis Kelamin");
      if (!this.state.tanggal_lahir) missingFields.push("Tanggal Lahir");
      if (!this.state.tahun_ajaran_create) missingFields.push("Tahun Ajaran");

      this.setState({
        show_alert: true,
        title_alert: "Data Tidak Lengkap",
        icon_alert: "error",
        message_alert: `Mohon lengkapi data berikut: ${missingFields.join(", ")}`,
        simpleLoading: false,
      });
    } else {
      axios
        .post(
          this.state.url_update,
          {
            id: this.state.id_edit,
            username: this.state.username,
            email: this.state.email,
            password: this.state.password,
            nama: this.state.nama,
            tahun_ajaran: this.state.tahun_ajaran_create,
            kode_pendaftaran: this.state.nisn,
            no_handphone: this.state.no_handphone,
            jenis_kelamin: this.state.jenis_kelamin,
            tanggal_lahir: this.state.tanggal_lahir,
            // updated_at          : new Date(),
            updated_by: this.state.institusi_id_select,
            type: "siswa",
          },
          { headers: { Authorization: tokenApi } }
        )
        .then((res) => {
          this.setState({
            show_alert: true,
            title_alert: "Berhasil",
            icon_alert: "success",
            message_alert: res.data.messages[0],
            simpleLoading: false,
          });
          this.hideModalEdit();
          this.dt.fetchEntities(
            `&query=${this.state.query}&tahun_ajaran=${this.state.tahun_ajaran_search}&paginate=${this.state.mode_show}`
          );
        })
        .catch((err) => {
          const response = err.response;
          let errorMessage = "Terjadi kesalahan saat menyimpan data. Silakan coba lagi.";

          if (response) {
            switch (response.status) {
              case 422:
                if (response.data.messages && response.data.messages.length > 0) {
                  errorMessage = response.data.messages.join(". ");
                }
                break;
              case 409:
                errorMessage = "Data yang Anda masukkan sudah ada di sistem (duplikat). Silakan periksa kembali username atau email.";
                break;
              case 500:
                errorMessage = "Terjadi kesalahan pada server. Silakan coba beberapa saat lagi atau hubungi administrator.";
                break;
              case 404:
                errorMessage = "Data tidak ditemukan. Mungkin data sudah dihapus oleh pengguna lain.";
                break;
              case 401:
                errorMessage = "Sesi Anda telah berakhir. Silakan login kembali.";
                break;
              case 403:
                errorMessage = "Anda tidak memiliki izin untuk mengubah data ini.";
                break;
              case 400:
                errorMessage = "Data yang dikirim tidak valid. Silakan periksa kembali form Anda.";
                break;
              case 408:
                errorMessage = "Koneksi timeout. Silakan periksa koneksi internet Anda dan coba lagi.";
                break;
              case 429:
                errorMessage = "Terlalu banyak permintaan. Silakan tunggu beberapa saat sebelum mencoba lagi.";
                break;
            }
          } else if (err.message === 'Network Error') {
            errorMessage = "Tidak dapat terhubung ke server. Silakan periksa koneksi internet Anda.";
          }

          this.setState({
            show_alert: true,
            title_alert: "Gagal Menyimpan",
            icon_alert: "error",
            message_alert: errorMessage,
            simpleLoading: false,
          });
        });
    }
  }

  // Create Siswa
  showModalTambah() {
    this.setState({ modal_tambah: true });
  }

  hideModalTambah() {
    this.setState({
      modal_tambah: false,
      nama: "",
      nisn: "",
      jenis_kelamin: "",
      tanggal_lahir: "",
    });
  }

  create(event) {
    event.preventDefault();
    this.setState({ simpleLoading: true });
    if (
      this.state.nama == "" ||
      this.state.nisn == "" ||
      this.state.jenis_kelamin == "" ||
      this.state.tanggal_lahir == "" ||
      this.state.tahun_ajaran_create == ""
    ) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "error",
        message_alert: "Isi form dengan benar",
        simpleLoading: false,
      });
    } else {
      axios
        .post(
          this.state.url_create,
          {
            username: this.state.username,
            email: this.state.email,
            password: this.state.password,
            nama: this.state.nama,
            tahun_ajaran: this.state.tahun_ajaran_create,
            kode_pendaftaran: this.state.nisn,
            no_handphone: this.state.no_handphone,
            jenis_kelamin: this.state.jenis_kelamin,
            tanggal_lahir: this.state.tanggal_lahir,
            user_institusi_id: this.state.institusi_id_select,
            created_by: this.state.institusi_id_select,
            created_at: new Date(),
            type: "siswa",
          },
          { headers: { Authorization: tokenApi } }
        )
        .then((res) => {
          this.setState({
            show_alert: true,
            title_alert: "Berhasil",
            icon_alert: "success",
            message_alert: res.data.messages[0],
            simpleLoading: false,
          });
          this.dt.fetchEntities(
            `&query=${this.state.query}&tahun_ajaran=${this.state.tahun_ajaran_search}&paginate=${this.state.mode_show}`
          );
          this.dt.loadingCreate();
          this.hideModalTambah();
        })
        .catch((err) => {
          this.alertMessage(err.response);
        });
    }
  }

  // Delete - Show progress modal
  delete(data, userName = "User Siswa") {
    // Reset delete state and open modal
    this.setState({
      modal_delete_progress: true,
      delete_type: 'single',
      delete_user_id: data,
      delete_user_name: userName,
      delete_steps: [
        { name: "Menghapus relasi mata pelajaran siswa", status: "pending" },
        { name: "Menghapus relasi rombel siswa", status: "pending" },
        { name: "Menghapus relasi orang tua", status: "pending" },
        { name: "Menghapus akun SSO siswa", status: "pending" },
        { name: "Menghapus data user siswa", status: "pending" },
      ],
      delete_current_step: 0,
      delete_error: null,
      is_deleting: false,
      delete_complete: false,
    });
  }

  // Hide delete progress modal
  hideDeleteProgressModal = () => {
    this.setState({ modal_delete_progress: false });
    // Refresh table if delete was successful
    if (this.state.delete_complete) {
      this.dt.fetchEntities(
        `&query=${this.state.query}&tahun_ajaran=${this.state.tahun_ajaran_search}&paginate=${this.state.mode_show}`
      );
      this.showCount();
    }
  };

  // Execute delete with progress simulation
  executeDelete = () => {
    if (this.state.delete_type === 'multiple') {
      this.setState({ is_deleting: true });
      this.executeBulkDeleteNextBatch(0);
      return;
    }

    this.setState({ is_deleting: true });

    // Simulate progress through steps while actual delete runs
    const simulateProgress = (stepIndex) => {
      if (stepIndex >= this.state.delete_steps.length) return;

      const newSteps = [...this.state.delete_steps];
      newSteps[stepIndex].status = "running";
      this.setState({ delete_steps: newSteps, delete_current_step: stepIndex });
    };

    // Start simulating progress
    let currentStep = 0;
    simulateProgress(currentStep);

    const progressInterval = setInterval(() => {
      currentStep++;
      if (currentStep < this.state.delete_steps.length) {
        // Mark previous as success, current as running
        const newSteps = [...this.state.delete_steps];
        newSteps[currentStep - 1].status = "success";
        newSteps[currentStep].status = "running";
        this.setState({ delete_steps: newSteps, delete_current_step: currentStep });
      }
    }, 400); // Simulate step every 400ms

    // Execute actual delete
    axios
      .delete(this.state.url_delete + this.state.delete_user_id, {
        headers: { Authorization: tokenApi },
      })
      .then((res) => {
        clearInterval(progressInterval);

        // Mark all steps as success
        const newSteps = this.state.delete_steps.map((step) => ({
          ...step,
          status: "success",
        }));

        this.setState({
          delete_steps: newSteps,
          is_deleting: false,
          delete_complete: true,
        });
      })
      .catch((err) => {
        clearInterval(progressInterval);

        // Determine which step failed
        let errorMessage = "Terjadi kesalahan, silakan coba lagi";

        if (err.response && err.response.data) {
          const errorData = err.response.data;
          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.messages) {
            errorMessage = Array.isArray(errorData.messages)
              ? errorData.messages[0]
              : errorData.messages;
          }
        } else if (!err.response) {
          errorMessage = "Periksa koneksi internet anda";
        }

        // Mark current step as error, keep previous as success
        const newSteps = this.state.delete_steps.map((step, index) => ({
          ...step,
          status:
            index < this.state.delete_current_step
              ? "success"
              : index === this.state.delete_current_step
                ? "error"
                : "pending",
        }));

        this.setState({
          delete_steps: newSteps,
          is_deleting: false,
          delete_error: errorMessage,
        });
      });
  };

  // Execute bulk delete next batch sequentially
  executeBulkDeleteNextBatch = (stepIndex) => {
    const { delete_steps } = this.state;
    if (stepIndex >= delete_steps.length) {
      // Completed all batches!
      this.setState({
        is_deleting: false,
        delete_complete: true,
      });
      return;
    }

    // Set current step to running
    const newSteps = [...delete_steps];
    newSteps[stepIndex].status = "running";
    this.setState({ delete_steps: newSteps, delete_current_step: stepIndex });

    // Call bulk delete API for this batch
    const batchIds = delete_steps[stepIndex].ids;
    axios
      .post(
        this.state.url_delete_m,
        { id: batchIds },
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        if (res.data.status === false) {
          // Failed!
          const failedSteps = this.state.delete_steps.map((step, idx) => ({
            ...step,
            status: idx < stepIndex ? "success" : idx === stepIndex ? "error" : "pending"
          }));
          this.setState({
            delete_steps: failedSteps,
            is_deleting: false,
            delete_error: (res.data.messages && Array.isArray(res.data.messages)) 
              ? res.data.messages[0] 
              : (res.data.messages || "Gagal menghapus batch data siswa"),
          });
        } else {
          // Success for this batch, move to next!
          const successSteps = [...this.state.delete_steps];
          successSteps[stepIndex].status = "success";
          this.setState({ delete_steps: successSteps }, () => {
            this.executeBulkDeleteNextBatch(stepIndex + 1);
          });
        }
      })
      .catch((err) => {
        let errorMessage = "Terjadi kesalahan, silakan coba lagi";
        if (err.response && err.response.data) {
          const errorData = err.response.data;
          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.messages) {
            errorMessage = Array.isArray(errorData.messages)
              ? errorData.messages[0]
              : errorData.messages;
          }
        }
        const failedSteps = this.state.delete_steps.map((step, idx) => ({
          ...step,
          status: idx < stepIndex ? "success" : idx === stepIndex ? "error" : "pending"
        }));
        this.setState({
          delete_steps: failedSteps,
          is_deleting: false,
          delete_error: errorMessage,
        });
      });
  };

  // Retry delete after error
  retryDelete = () => {
    if (this.state.delete_type === 'multiple') {
      const failedStepIndex = this.state.delete_steps.findIndex(
        (step) => step.status === "error" || step.status === "pending"
      );
      const startFrom = failedStepIndex >= 0 ? failedStepIndex : 0;
      
      const resetSteps = this.state.delete_steps.map((step, idx) => ({
        ...step,
        status: idx < startFrom ? "success" : "pending",
      }));

      this.setState(
        {
          delete_steps: resetSteps,
          delete_error: null,
          delete_current_step: startFrom,
          is_deleting: true,
        },
        () => {
          this.executeBulkDeleteNextBatch(startFrom);
        }
      );
      return;
    }

    // Reset steps and try again for single delete
    this.setState(
      {
        delete_steps: [
          { name: "Menghapus relasi mata pelajaran siswa", status: "pending" },
          { name: "Menghapus relasi rombel siswa", status: "pending" },
          { name: "Menghapus relasi orang tua", status: "pending" },
          { name: "Menghapus akun SSO siswa", status: "pending" },
          { name: "Menghapus data user siswa", status: "pending" },
        ],
        delete_error: null,
        delete_current_step: 0,
      },
      () => {
        this.executeDelete();
      }
    );
  };

  checkAll(e) {
    e.preventDefault();
    this.setState({ loading_check: true }, function () {
      this.setState({ checkAll: true, loading_check: false });
    });
  }

  unCheckAll(e) {
    e.preventDefault();
    this.setState({ loading_check: true }, function () {
      this.setState({ checkAll: false, loading_check: false });
    });
  }

  deleteMulti() {
    var checkboxes = document.getElementsByName("check_data[]");
    var vals = [];
    for (var i = 0, n = checkboxes.length; i < n; i++) {
      if (checkboxes[i].checked) {
        vals.push(checkboxes[i].value);
      }
    }

    if (vals.length == 0) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Mohon centang data terlebih dahulu",
        disabledFilter: false,
        loading_delete: false,
        checkAll: false,
      });
    } else {
      // Chunk size of 10 to prevent timeouts
      const batchSize = 10;
      const total = vals.length;
      const steps = [];
      for (let i = 0; i < total; i += batchSize) {
        const batchNum = Math.floor(i / batchSize) + 1;
        const end = Math.min(i + batchSize, total);
        steps.push({
          name: `Menghapus Batch ${batchNum} (${i + 1} - ${end} dari ${total} siswa)`,
          status: "pending",
          ids: vals.slice(i, i + batchSize)
        });
      }

      this.setState({
        modal_delete_progress: true,
        delete_type: 'multiple',
        delete_user_id: null,
        delete_user_ids: vals,
        delete_user_name: `Hapus Massal (${total} Siswa)`,
        delete_steps: steps,
        delete_current_step: 0,
        delete_error: null,
        is_deleting: false,
        delete_complete: false,
      });
    }
  }

  // Generate All Token
  generateAllToken() {
    this.setState({ loading_generate_token: true });
    this.setState({ loading_token: true });
    axios
      .post(
        this.state.url_generate_all_token,
        { user_institusi_id: this.state.institusi_id_select },
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        this.setState({ loading_generate_token: false });
        this.setState({ loading_token: false });
        if (res.data.status === true) {
          this.dt.loading();
          this.dt.resetPage(
            `&status=${this.state.selectStatus}&paginate=${this.state.mode_show}&query=${this.state.query}`
          );
        } else {
          swal.fire({
            title: "Gagal",
            text: "Ada Kesalahan",
            icon: "error",
          });
        }
        this.setState({ loading_token: false });
      });
  }

  // Generate Token
  generate_token(data) {
    this.setState({ loading_token: data });
    axios
      .post(
        this.state.url_token_user,
        { user_id: data },
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        this.setState({ loading_token: false });
        document.getElementById("token" + data + "").innerHTML =
          "" + res.data.token + "";
        var element = document.getElementById("myButton" + data + "");
        element.classList.add("hidden");
      });
  }

  sendMailActivation() {
    this.setState({ loading_mail: true });
    var checkboxes = document.getElementsByName("check_data[]");
    var vals = [];
    var tokensEmpty = false;

    for (var i = 0, n = checkboxes.length; i < n; i++) {
      if (checkboxes[i].checked) {
        vals.push(checkboxes[i].value);
        const tokenElement = document.getElementById("token" + checkboxes[i].value);
        if (tokenElement && tokenElement.innerHTML.trim() === "") {
          tokensEmpty = true;
          break;
        }
      }
    }

    if (vals.length == 0) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Mohon centang data terlebih dahulu",
        disabledFilter: false,
        loading_mail: false,
        checkAll: false,
      });
    } else if (tokensEmpty) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Terdapat user yang belum memiliki token. Harap generate token terlebih dahulu.",
        loading_mail: false,
        checkAll: false,
      });
    } else {
      swal
        .fire({
          title: "Peringatan",
          text: "Apakah anda yakin mengirim email aktivasi user yang dipilih?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Iya`,
          cancelButtonText: "Batal",
        })
        .then((result) => {
          if (result.value == true) {
            axios
              .post(
                this.state.url_send_mail,
                { id: vals },
                { headers: { Authorization: tokenApi } }
              )
              .then((res) => {
                if (res.data.status == false) {
                  this.setState({
                    show_alert: true,
                    title_alert: "Gagal",
                    icon_alert: "error",
                    message_alert:
                      res.data.messages[0] +
                      "Berhasil : " +
                      res.data.berhasil +
                      "Gagal : " +
                      res.data.gagal,
                    loading_mail: false,
                    checkAll: false,
                  });
                  this.dt.loading();
                  this.dt.resetPage();
                } else {
                  this.setState({
                    show_alert: true,
                    title_alert: "Berhasil",
                    icon_alert: "success",
                    message_alert: res.data.messages[0],
                    loading_mail: false,
                    checkAll: false,
                  });
                  this.dt.loading();
                  this.dt.resetPage();
                }
              })
              .catch((err) => {
                this.setState({ loading_mail: false });
                // this.alertMessage(err.response);
              });
          } else if (result.dismiss == "cancel") {
            this.setState({ loading_mail: false });
          } else if (result.dismiss == "backdrop") {
            this.setState({ loading_mail: false });
          }
        });
    }
  }

  sendWAActivation() {
    this.setState({ loading_mail: true });
    var checkboxes = document.getElementsByName("check_data[]");
    var vals = [];
    var tokensEmpty = false;

    for (var i = 0, n = checkboxes.length; i < n; i++) {
      if (checkboxes[i].checked) {
        vals.push(checkboxes[i].value);
        const tokenElement = document.getElementById("token" + checkboxes[i].value);
        if (tokenElement && tokenElement.innerHTML.trim() === "") {
          tokensEmpty = true;
          break;
        }
      }
    }

    if (vals.length == 0) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Mohon centang data terlebih dahulu",
        disabledFilter: false,
        loading_mail: false,
        checkAll: false,
      });
    } else if (tokensEmpty) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Terdapat user yang belum memiliki token. Harap generate token terlebih dahulu.",
        loading_mail: false,
        checkAll: false,
      });
    } else {
      swal
        .fire({
          title: "Peringatan",
          text: "Apakah anda yakin mengirim email aktivasi user yang dipilih?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Iya`,
          cancelButtonText: "Batal",
        })
        .then((result) => {
          if (result.value == true) {
            axios
              .post(
                this.state.url_send_wa,
                { id: vals },
                { headers: { Authorization: tokenApi } }
              )
              .then((res) => {
                if (res.data.status == false) {
                  this.setState({
                    show_alert: true,
                    title_alert: "Gagal",
                    icon_alert: "error",
                    message_alert:
                      res.data.messages[0] +
                      "Berhasil : " +
                      res.data.berhasil +
                      "Gagal : " +
                      res.data.gagal,
                    loading_mail: false,
                    checkAll: false,
                  });
                  this.dt.loading();
                  this.dt.resetPage();
                } else {
                  this.setState({
                    show_alert: true,
                    title_alert: "Berhasil",
                    icon_alert: "success",
                    message_alert: res.data.messages[0],
                    loading_mail: false,
                    checkAll: false,
                  });
                  this.dt.loading();
                  this.dt.resetPage();
                }
              })
              .catch((err) => {
                this.setState({ loading_mail: false });
                // this.alertMessage(err.response);
              });
          } else if (result.dismiss == "cancel") {
            this.setState({ loading_mail: false });
          } else if (result.dismiss == "backdrop") {
            this.setState({ loading_mail: false });
          }
        });
    }
  }

  // Generate Activation Code Modal Functions
  showModalGenerateActivation() {
    this.setState({
      modal_generate_activation: true,
      activation_tahun_ajaran: "",
      activation_prefix: "",
      activation_jumlah_token: "",
      activation_token_sama: false,
      activation_mode: "auto",
      activation_manual_list: [{ kode_pendaftaran: "", token: "" }]
    });
  }

  hideModalGenerateActivation() {
    this.setState({
      modal_generate_activation: false,
      activation_tahun_ajaran: "",
      activation_prefix: "",
      activation_jumlah_token: "",
      activation_token_sama: false,
      activation_mode: "auto",
      activation_manual_list: [{ kode_pendaftaran: "", token: "" }]
    });
  }

  activationTahunAjaran(e) {
    this.setState({ activation_tahun_ajaran: e.value });
  }

  activationPrefix(e) {
    this.setState({ activation_prefix: e.target.value });
  }

  activationJumlahToken(e) {
    this.setState({ activation_jumlah_token: e.target.value });
  }

  activationTokenSama(e) {
    this.setState({ activation_token_sama: e.target.checked });
  }

  // Ganti mode antara "auto" (jumlah saja) dan "manual" (isi kode & token sendiri)
  activationSetMode(mode) {
    this.setState({
      activation_mode: mode,
      activation_manual_list:
        mode === "manual" && this.state.activation_manual_list.length === 0
          ? [{ kode_pendaftaran: "", token: "" }]
          : this.state.activation_manual_list
    });
  }

  // Ubah nilai kode_pendaftaran / token pada baris manual tertentu
  activationManualChange(index, field, value) {
    const list = [...this.state.activation_manual_list];
    list[index] = { ...list[index], [field]: value };
    this.setState({ activation_manual_list: list });
  }

  // Tambah baris input manual baru
  activationAddManualRow() {
    this.setState({
      activation_manual_list: [
        ...this.state.activation_manual_list,
        { kode_pendaftaran: "", token: "" }
      ]
    });
  }

  // Hapus baris input manual
  activationRemoveManualRow(index) {
    const list = [...this.state.activation_manual_list];
    if (list.length <= 1) return; // minimal 1 baris
    list.splice(index, 1);
    this.setState({ activation_manual_list: list });
  }

  generateActivationCodes(e) {
    e.preventDefault();

    if (!this.state.activation_tahun_ajaran) {
      this.setState({
        show_alert: true,
        title_alert: "Validasi",
        icon_alert: "warning",
        message_alert: "Tahun ajaran harus dipilih!"
      });
      return;
    }

    const isManual = this.state.activation_mode === "manual";

    let jumlah_token;
    let kode_pendaftaran_arr = [];
    let token_arr = [];

    if (isManual) {
      // Validasi mode manual: setiap baris wajib punya kode_pendaftaran & token
      const list = this.state.activation_manual_list;
      const invalid = list.some(
        (row) => !row.kode_pendaftaran || !row.token
      );

      if (list.length === 0 || invalid) {
        this.setState({
          show_alert: true,
          title_alert: "Validasi",
          icon_alert: "warning",
          message_alert: "Kode pendaftaran dan token wajib diisi untuk setiap baris!"
        });
        return;
      }

      jumlah_token = list.length;
      kode_pendaftaran_arr = list.map((row) => row.kode_pendaftaran);
      token_arr = list.map((row) => row.token);
    } else {
      if (!this.state.activation_jumlah_token || this.state.activation_jumlah_token <= 0) {
        this.setState({
          show_alert: true,
          title_alert: "Validasi",
          icon_alert: "warning",
          message_alert: "Jumlah token harus diisi dan lebih dari 0!"
        });
        return;
      }
      jumlah_token = parseInt(this.state.activation_jumlah_token);
    }

    this.setState({ loading_generate_activation: true });

    const data = {
      user_institusi_id: this.state.institusi_id_select,
      tahun_ajaran: this.state.activation_tahun_ajaran,
      prefix: this.state.activation_prefix || "",
      jumlah_token: jumlah_token,
      token_sama: isManual ? false : this.state.activation_token_sama
    };

    if (isManual) {
      data.kode_pendaftaran = kode_pendaftaran_arr;
      data.token = token_arr;
    }

    axios
      .post(this.state.url_generate_activation, data, {
        headers: { Authorization: tokenApi }
      })
      .then((res) => {
        this.setState({ loading_generate_activation: false });
        if (res.data.status) {
          const totalCreated = res.data.data?.total_created ?? 0;
          const totalFailed = res.data.data?.total_failed ?? 0;
          const failedList = res.data.data?.failed ?? [];

          if (totalCreated === 0) {
            // Tidak ada satupun token yang berhasil dibuat (mis. kode/token
            // sudah dipakai) -> jangan tampilkan sebagai berhasil
            const friendlyReason = (reason) => {
              if (!reason) return "gagal dibuat";
              if (reason.toLowerCase().includes("sudah dipakai")) return "sudah pernah digunakan";
              if (reason.toLowerCase().includes("sudah ada setelah")) return "gagal dibuat karena bentrok dengan kode lain";
              return reason;
            };
            const failReasons = failedList
              .map((f) => `Kode ${f.kode_pendaftaran} ${friendlyReason(f.reason)}`)
              .join(", ");
            this.setState({
              show_alert: true,
              title_alert: "Gagal",
              icon_alert: "error",
              message_alert: failReasons
                ? `${failReasons}.`
                : res.data.message
            });
            return;
          }

          if (totalFailed > 0) {
            // Sebagian berhasil, sebagian gagal
            this.setState({
              show_alert: true,
              title_alert: "Sebagian Berhasil",
              icon_alert: "warning",
              message_alert: res.data.message,
              modal_generate_activation: false
            });
          } else {
            this.setState({
              show_alert: true,
              title_alert: "Berhasil",
              icon_alert: "success",
              message_alert: res.data.message,
              modal_generate_activation: false
            });
          }
          // Refresh data table
          this.dt.loading();
          this.dt.resetPage();
        } else {
          this.setState({
            show_alert: true,
            title_alert: "Gagal",
            icon_alert: "error",
            message_alert: res.data.message || "Gagal membuat kode aktivasi"
          });
        }
      })
      .catch((err) => {
        this.setState({ loading_generate_activation: false });
        let errorMessage = "Terjadi kesalahan sistem";
        if (err.response && err.response.data && err.response.data.messages) {
          errorMessage = Array.isArray(err.response.data.messages)
            ? err.response.data.messages.join(", ")
            : err.response.data.messages;
        }
        this.setState({
          show_alert: true,
          title_alert: "Error",
          icon_alert: "error",
          message_alert: errorMessage
        });
      });
  }

  activationImportFile(e) {
    this.setState({ activation_import_file: e.target.files[0] });
  }

  importActivationCodes(e) {
    e.preventDefault();

    if (!this.state.activation_import_file) {
      this.setState({
        show_alert: true,
        title_alert: "Validasi",
        icon_alert: "warning",
        message_alert: "File Excel harus dipilih!"
      });
      return;
    }

    this.setState({
      loading_import_activation: true,
      is_importing: true,
      import_progress: 0,
      import_total: 0,
      import_current: 0
    });

    const formData = new FormData();
    formData.append('file', this.state.activation_import_file);
    formData.append('user_institusi_id', this.state.institusi_id_select);

    axios
      .post(this.state.url_import_activation, formData, {
        headers: {
          Authorization: tokenApi,
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        if (res.data.status) {
          // Backend returns job_id for polling
          const jobId = res.data.job_id;

          if (jobId) {
            console.log('Import started with job ID:', jobId);
            this.setState({
              import_job_id: jobId,
              activation_import_file: null
            });

            // Start polling for progress
            this.startProgressPolling(jobId);
          } else {
            // Fallback: direct response without polling
            this.handleImportComplete(res.data);
          }
        } else {
          this.setState({
            show_alert: true,
            title_alert: "Gagal",
            icon_alert: "error",
            message_alert: res.data.message || "Gagal import kode aktivasi",
            loading_import_activation: false,
            is_importing: false,
            activation_import_file: null
          });
        }
      })
      .catch((err) => {
        this.setState({
          loading_import_activation: false,
          activation_import_file: null,
          is_importing: false,
          import_progress: 0
        });
        let errorMessage = "Terjadi kesalahan sistem";
        if (err.response && err.response.data && err.response.data.messages) {
          errorMessage = Array.isArray(err.response.data.messages)
            ? err.response.data.messages.join(", ")
            : err.response.data.messages;
        }
        this.setState({
          show_alert: true,
          title_alert: "Error",
          icon_alert: "error",
          message_alert: errorMessage
        });
      });
  }

  startProgressPolling(jobId) {
    const pollingInterval = setInterval(() => {
      axios
        .get(this.state.url_import_progress + jobId, {
          headers: { Authorization: tokenApi }
        })
        .then((res) => {
          if (res.data.status) {
            const { processed, total, percentage, completed } = res.data;

            this.setState({
              import_current: processed || 0,
              import_total: total || 0,
              import_progress: percentage || 0
            });

            console.log(`Progress: ${processed}/${total} (${percentage}%)`);

            // Check if completed
            if (completed) {
              clearInterval(pollingInterval);
              this.setState({ polling_interval: null });

              // Get final result
              this.handleImportComplete(res.data);
            }
          }
        })
        .catch((err) => {
          console.error('Polling error:', err);
          // Continue polling even on error, unless too many failures
        });
    }, 2000); // Poll every 2 seconds

    this.setState({ polling_interval: pollingInterval });
  }

  handleImportComplete(data) {
    console.log('Import completed, final data:', data);

    const backendSuccess = data.success ||
      (data.data && data.data.created) ||
      data.created ||
      [];
    const backendFailed = data.failed ||
      (data.data && data.data.failed) ||
      [];

    console.log('Backend success:', backendSuccess);
    console.log('Backend failed:', backendFailed);

    // Map to consistent format
    const successList = backendSuccess.map(item => ({
      nama: item.nama || item.username || `Row ${item.row || '?'}`,
      username: item.username || item.kode_pendaftaran || '-',
      kode_pendaftaran: item.kode_pendaftaran || item.token || '-'
    }));

    const failedList = backendFailed.map(item => ({
      nama: `Baris ${item.row || '?'} (${item.kode_pendaftaran || '-'})`,
      username: item.username || '-',
      kode_pendaftaran: `Baris ${item.row || '?'} (${item.kode_pendaftaran || '-'})`,
      reason: item.reason || 'Unknown error'
    }));

    console.log('Mapped success:', successList.length, successList.slice(0, 3));
    console.log('Mapped failed:', failedList.length, failedList.slice(0, 3));

    this.setState({
      import_success: successList,
      import_failed: failedList,
      modal_generate_activation: false,
      loading_import_activation: false,
      is_importing: false,
      import_progress: 100,
      import_job_id: null
    });

    // Show detailed result modal
    this.showModalImportResult();

    // Refresh data table
    this.dt.loading();
    this.dt.resetPage();
  }

  showModalImportResult() {
    this.setState({ modal_import_result: true });
  }

  hideModalImportResult() {
    // Clear polling if still active
    if (this.state.polling_interval) {
      clearInterval(this.state.polling_interval);
    }

    this.setState({
      modal_import_result: false,
      import_success: [],
      import_failed: [],
      import_progress: 0,
      import_job_id: null,
      polling_interval: null
    });
  }

  // Modal Detail
  showModalDetail(data) {
    this.setState({
      modal_detail: true,
      loading_detail: true,
    });
    axios
      .get(this.state.url_detail + data, {
        headers: { Authorization: tokenApi },
      })
      .then((res) => {
        this.setState({ data_detail: res.data.data, loading_detail: false });
      });
  }

  hideModalDetail() {
    this.setState({ data_detail: "", modal_detail: false });
  }

  // Cetak Function
  showModalCetak() {
    this.setState(
      {
        modal_cetak: true,
        queryToken: `&paginate=10&search=`,
      },
      function () {
        this.dtt.fetchEntities(this.state.queryToken);
      }
    );
    // axios.get(`${this.state.url_table_token}/${this.state.institusi_id_select}?paginate=10`, {headers:{Authorization:tokenApi}}).then(res => {
    //   this.setState({ data_print: res.data, loading_print: false });
    // });
  }

  showTableToken() {
    if (this.state.queryToken != "") {
      return (
        <div>
          <DataTable
            ref={(dtt) => {
              this.dtt = dtt;
            }}
            action={{
              jenis_kelamin: (col, data) => {
                var jekel = "";
                if (col.jenis_kelamin == 1) {
                  jekel = "Laki - Laki";
                }

                if (col.jenis_kelamin == 0) {
                  jekel = "Perempuan";
                }

                if (col.jenis_kelamin == null) {
                  jekel = "Belum diketahui";
                }
                return <p className="text-sm">{jekel}</p>;
              },
              pilih: (col, data) => {
                return (
                  <input
                    type="checkbox"
                    name="check_data[]"
                    className="check"
                    id="check_data"
                    value={data.id}
                    defaultChecked={this.state.PilihSemua ? true : null}
                  />
                );
              },
            }}
            url={
              this.state.url_table_token + "/" + this.state.institusi_id_select
            }
            columns={[
              {
                index: "kode_pendaftaran",
                label: "Kode Pendaftaran",
              },
              {
                index: "token",
                label: "token",
              },
              {
                index: "nama",
                label: "nama",
              },
              {
                index: "jenis_kelamin",
                label: "Jenis Kelamin",
              },
              {
                index: "pilih",
                label: "pilih",
              },
            ]}
          />
        </div>
      );
    }
  }

  hideModalCetak() {
    this.setState({
      modal_cetak: false,
      queryToken: "",
      pilihSemua: false,
      searchToken: "",
      mode_show_token: 10,
    });
  }

  printToken(e) {
    e.preventDefault();
    this.setState({ loading_saveprint: true });
    var checkboxes = document.getElementsByName("check_data[]");
    var vals = "";
    var str = "";
    for (var i = 0, n = checkboxes.length; i < n; i++) {
      if (checkboxes[i].checked) {
        vals += "," + checkboxes[i].value;
        str = vals.substr(1);
      }
    }

    if (str == "") {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "error",
        message_alert: "Pilih atau centang User terlebih dahulu",
        loading_saveprint: false,
      });
    } else {
      axios
        .post(
          this.state.url_print_token,
          { id: str },
          { headers: { Authorization: tokenApi } }
        )
        .then((res) => {
          this.setState({ loading_saveprint: false });
          var mywindow = window.open("", "new div", "height=400,width=600");
          var jekel = ["Perempuan", "Laki - Laki"];
          res.data.map((person, index) => {
            mywindow.document.write(
              `<html>
              <head>
              </head>
              <body style="display: flex; flex-wrap: wrap; align-content: flex-start;">
                <table style="width:48%; margin-bottom:10px; margin-left: 10px; border-radius: 8px; padding: 4px;" border="1px solid #000000">
                  <tr>
                    <td style="border: 0px solid #000000; font-size: 11px;">KODE PENDAFTARAN</td>
                    <td style="border: 0px solid #000000; font-size: 11px; width: 60%;">: ${person.kode_pendaftaran
              }</td>
                  </tr>
                  <tr>
                    <td style="border: 0px solid #000000; font-size: 11px;">TOKEN</td>
                    <td style="border: 0px solid #000000; font-size: 11px; width: 60%;">: ${person.token
              }</td>
                  </tr>
                  <tr>
                    <td style="border: 0px solid #000000; font-size: 11px;">NAMA</td>
                    <td style="border: 0px solid #000000; font-size: 11px; width: 60%;">: ${person.nama
              }</td>
                  </tr>
                  <tr>
                    <td style="border: 0px solid #000000; font-size: 11px;">JENIS KELAMIN</td>
                    <td style="border: 0px solid #000000; font-size: 11px; width: 60%;">: ${jekel[person.jenis_kelamin]
              }</td>
                  </tr>
                </table>
              </body>
            </html>`
            );
          });
          mywindow.print();
          mywindow.close();
        })
        .catch((err) => {
          this.alertMessage(err.response);
          this.setState({ loading_saveprint: false });
        });
    }
  }

  // reset search
  resetSearch(event) {
    event.preventDefault();
    document.getElementById("search").value = "";
    this.dt.fetchEntities(
      `&query=${this.state.query}&tahun_ajaran=${this.state.tahun_ajaran_search}&paginate=${this.state.mode_show}`
    );
  }

  // export
  export(event) {
    event.preventDefault();
    this.setState({ loading_export: true });
    axios({
      url: this.state.url_export_data + this.state.institusi_id_select,
      method: "POST",
      responseType: "blob", // important
      headers: { Authorization: tokenApi },
      data: {
        status: this.state.selectStatus,
      },
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        var tanggal = new Date();
        var bulan = tanggal.getMonth() + 1;
        if (bulan < 10 ? (bulan = `0${bulan}`) : "");
        link.setAttribute(
          "download",
          "Siswa_" +
          tanggal.getDate() +
          "-" +
          bulan +
          "-" +
          tanggal.getFullYear() +
          "_TIME(" +
          tanggal.getHours() +
          "-" +
          tanggal.getMinutes() +
          ").xlsx"
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
        this.setState({ loading_export: false });
      })
      .catch((err) => {
        this.alertMessage(err);
        this.setState({ loading_export: false });
      });
  }

  // Modal import
  showModalImport() {
    this.setState({ modal_excel_wizard: true }); // Use new wizard
  }

  hideModalImport() {
    this.setState({ modal_excel_wizard: false, modal_import: false });
  }

  import(event) {
    event.preventDefault();

    this.setState({ simpleLoading: true });

    const data = new FormData();
    data.append("file", this.state.import_file);
    axios
      .post(this.state.url_import_data, data, {
        headers: { Authorization: tokenApi },
      })
      .then((res) => {
        if (res.data.status == false) {
          this.setState({
            show_alert: true,
            title_alert: "Gagal",
            icon_alert: "error",
            message_alert: res.data.messages[0],
            simpleLoading: false,
          });
        } else {
          this.setState({ simpleLoading: false });
          this.showModalPrevImport(res.data.data);
          this.hideModalImport();
        }
      })
      .catch((err) => {
        this.alertMessage(err.response);
      });
  }

  // Modal Import Detail
  showModalPrevImport(data) {
    this.setState({
      data_preview: data,
      modal_preview_import: true,
      simpleLoading: false,
    });
  }

  hideModalPrevImport() {
    this.setState({ modal_preview_import: false });
  }

  simpanImport(e) {
    e.preventDefault();
    // Use queue processing for better performance
    this.simpanImportQueue();
  }

  async simpanImportQueue() {
    const data = this.state.data_preview;
    const chunkSize = 50; // Process 50 records at a time
    const chunks = [];

    // Split data into chunks
    for (let i = 0; i < data.length; i += chunkSize) {
      chunks.push(data.slice(i, i + chunkSize));
    }

    console.log(`Total data: ${data.length}, Will process in ${chunks.length} chunks`);

    this.setState({
      simpleLoading: true,
      is_importing: true,
      import_total: data.length,
      import_current: 0,
      import_progress: 0,
      import_success: [],
      import_failed: []
    });

    let successItems = [];
    let failedItems = [];

    // Process each chunk
    for (let i = 0; i < chunks.length; i++) {
      try {
        console.log(`Processing chunk ${i + 1}/${chunks.length}, sending ${chunks[i].length} records`);

        const res = await axios.post(
          this.state.url_save_import_data + this.state.institusi_id_select,
          { data: chunks[i] },
          { headers: { Authorization: tokenApi } }
        );

        console.log(`Chunk ${i + 1} response:`, res.data);
        console.log(`Response structure check:`, {
          hasSuccess: !!res.data.success,
          hasCreated: !!res.data.created,
          hasDataCreated: !!(res.data.data && res.data.data.created),
          hasFailed: !!res.data.failed,
          hasDataFailed: !!(res.data.data && res.data.data.failed)
        });

        if (res.data.status) {
          // Backend returns data.created and data.failed (for importActivationCodes)
          // OR success/failed directly (for import_save if updated)
          const backendSuccess = res.data.success ||
            (res.data.data && res.data.data.created) ||
            res.data.created ||
            [];
          const backendFailed = res.data.failed ||
            (res.data.data && res.data.data.failed) ||
            [];

          // Track success - map created to success format
          if (backendSuccess.length > 0) {
            const mapped = backendSuccess.map(item => ({
              nama: item.nama || item.username || `Row ${item.row || '?'}`,
              username: item.username || item.kode_pendaftaran || '-',
              kode_pendaftaran: item.kode_pendaftaran || '-'
            }));
            successItems = [...successItems, ...mapped];
          }

          // Track failures
          if (backendFailed.length > 0) {
            const mapped = backendFailed.map(item => ({
              nama: item.nama || `Baris ${item.row || '?'}`,
              username: item.username || '-',
              kode_pendaftaran: item.kode_pendaftaran || '-',
              reason: item.reason || 'Unknown error'
            }));
            failedItems = [...failedItems, ...mapped];
          }
        } else {
          // If chunk failed completely, mark all items as failed
          const errorMsg = res.data.messages ? res.data.messages[0] : 'Unknown error';
          failedItems = [...failedItems, ...chunks[i].map(item => ({
            nama: item.nama,
            username: item.username,
            kode_pendaftaran: item.kode_pendaftaran,
            reason: errorMsg
          }))];
        }
      } catch (err) {
        console.error(`Error processing chunk ${i + 1}:`, err);
        // Mark all items in failed chunk
        const errorMsg = err.response?.data?.messages?.[0] || 'Network error';
        failedItems = [...failedItems, ...chunks[i].map(item => ({
          nama: item.nama,
          username: item.username,
          kode_pendaftaran: item.kode_pendaftaran,
          reason: errorMsg
        }))];
      }

      // Update progress after each chunk
      const processed = (i + 1) * chunkSize;
      const current = Math.min(processed, data.length);
      const progress = Math.round((current / data.length) * 100);

      console.log(`Progress: ${current}/${data.length} (${progress}%)`);

      this.setState({
        import_current: current,
        import_progress: progress,
        import_success: successItems,
        import_failed: failedItems
      });

      // Small delay to allow UI update
      await new Promise(resolve => setTimeout(resolve, 100));
    }

    console.log(`Import completed. Success: ${successItems.length}, Failed: ${failedItems.length}`);

    // Show result
    this.setState({
      simpleLoading: false,
      is_importing: false
    });

    this.hideModalPrevImport();
    this.showModalImportResult();

    // Refresh table
    this.dt.fetchEntities(
      `&paginate=${this.state.mode_show}&query=${this.state.query}`
    );
  }

  filterTahunAjaran(e) {
    if (e) {
      this.setState({ tahun_ajaran_search: e.value });
    } else {
      this.setState({ tahun_ajaran_search: "" });
    }
  }

  setFilter(e) {
    e.preventDefault();
    this.showCount();
    this.dt.resetPage(
      `&query=${this.state.query}&tahun_ajaran=${this.state.tahun_ajaran_search}&paginate=${this.state.mode_show}`
    );
    this.dt.loading();
  }

  changeStatus = (e) => {
    if (e) {
      this.setState(
        {
          selectStatus: e.value,
        },
        function () {
          this.dt.loading();
          this.dt.resetPage(
            `&status=${this.state.selectStatus}&paginate=${this.state.mode_show}&query=${this.state.query}`
          );
        }
      );
    } else {
      this.dt.loading();
      this.dt.resetPage(
        `&paginate=${this.state.mode_show}&query=${this.state.query}`
      );
    }
  };

  pilihSemua() {
    var checkboxes = document.getElementsByClassName("select-all").item(0)
      .checked;
    if (checkboxes == true) {
      this.setState({ PilihSemua: true }, function () {
        this.dtt.loading();
        this.dtt.fetchEntities(this.state.queryToken);
      });
    } else {
      this.setState({ PilihSemua: false }, function () {
        this.dtt.loading();
        this.dtt.fetchEntities(this.state.queryToken);
      });
    }
  }

  // Menampilkan modal dropzone foto profil
  showModalDropzoneImage() {
    this.setState({ modal_image: true });
  }

  // Tutup modal dropzone foto profil
  hideModalDropzoneImage() {
    this.setState({ modal_image: false });
  }

  render() {
    return (
      <div>
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm mx-auto p-6 mt-6 sm-container">
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
            <div>
              <div className="flex items-center gap-2">
                <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-blue-50 text-blue-600">
                  <i className="bx bxs-user text-xl"></i>
                </span>
                <h1 className="text-xl font-bold text-gray-900">
                  Manajemen Siswa
                </h1>
              </div>
              <p className="text-gray-500 text-sm mt-1">
                Kelola data akun siswa, buat token, export data, dan atur kode aktivasi.
              </p>
            </div>
            
            <div className="flex flex-wrap gap-2 items-center">
              {this.state.institusi_id_select !== "" ? (
                <>
                  <button
                    onClick={this.generateAllToken}
                    className="flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 hover:text-blue-600 transition-all duration-200 shadow-sm"
                    disabled={this.state.loading_generate_token}
                  >
                    {this.state.loading_generate_token ? (
                      <UserButtonLoading color="text-gray-500" />
                    ) : (
                      <>
                        <i className="bx bx-refresh text-lg"></i>
                        <span>Generate Token</span>
                      </>
                    )}
                  </button>

                  <button
                    onClick={this.showModalGenerateActivation}
                    className="flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 hover:text-blue-600 transition-all duration-200 shadow-sm"
                  >
                    <i className="bx bx-key text-lg"></i>
                    <span>Kode Aktivasi</span>
                  </button>

                  <button
                    onClick={this.export}
                    className="flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 hover:text-emerald-600 transition-all duration-200 shadow-sm"
                    disabled={this.state.loading_export}
                  >
                    {this.state.loading_export ? (
                      <UserButtonLoading color="text-gray-500" />
                    ) : (
                      <>
                        <i className="bx bx-export text-lg"></i>
                        <span>Export</span>
                      </>
                    )}
                  </button>

                  <button
                    onClick={this.showModalImport}
                    className="flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 hover:text-indigo-600 transition-all duration-200 shadow-sm"
                  >
                    <i className="bx bx-upload text-lg"></i>
                    <span>Upload</span>
                  </button>

                  <button
                    onClick={this.showModalCetak}
                    className="flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 hover:text-rose-600 transition-all duration-200 shadow-sm"
                  >
                    <i className="bx bx-printer text-lg"></i>
                    <span>Cetak</span>
                  </button>

                  <button
                    onClick={this.showModalDropzoneImage}
                    className="flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 hover:text-blue-600 transition-all duration-200 shadow-sm"
                  >
                    <i className="bx bx-image-add text-lg"></i>
                    <span>Foto Profil</span>
                  </button>

                  <button
                    onClick={this.showModalTambah}
                    className="flex items-center justify-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-all duration-200 shadow-md shadow-blue-500/10 hover:shadow-blue-500/20 active:scale-95"
                  >
                    <i className="bx bx-plus text-lg"></i>
                    <span>Tambah</span>
                  </button>
                </>
              ) : (
                <>
                  <Skeleton width={120} height={38} className="rounded-xl" />
                  <Skeleton width={120} height={38} className="rounded-xl" />
                  <Skeleton width={120} height={38} className="rounded-xl" />
                  <Skeleton width={120} height={38} className="rounded-xl" />
                </>
              )}
            </div>
          </div>
        </div>

        {/* alert */}
        <SweetAlert
          show={this.state.show_alert}
          title={this.state.title_alert}
          text={this.state.message_alert}
          type={this.state.icon_alert}
          onConfirm={() => this.setState({ show_alert: false })}
          onOutsideClick={() => this.setState({ show_alert: false })}
        />

        {/* Modal dropzone foto profil */}
        <ModalDropZoneImage showModal={this.state.modal_image} hideModal={this.hideModalDropzoneImage} type="SI" />

        {/* Modal Delete Progress */}
        <DeleteProgressModal
          show={this.state.modal_delete_progress}
          onHide={this.hideDeleteProgressModal}
          steps={this.state.delete_steps}
          error={this.state.delete_error}
          onConfirm={this.executeDelete}
          onRetry={this.retryDelete}
          isDeleting={this.state.is_deleting}
          isComplete={this.state.delete_complete}
          userName={this.state.delete_user_name}
        />

        {/* Modal Generate Activation Code */}
        <Modal show={this.state.modal_generate_activation} onHide={this.hideModalGenerateActivation}>
          <Modal.Header>Generate Activation Code</Modal.Header>
          <Modal.Body>
            <Tabs defaultActiveKey="form" id="activation-tabs" className="mb-3">
              <Tab eventKey="form" title="Form Manual">
                {/* Toggle Mode: Otomatis vs Manual */}
                <div className="w-full flex gap-2 mt-3 mb-2">
                  <button
                    type="button"
                    onClick={() => this.activationSetMode("auto")}
                    className={
                      this.state.activation_mode === "auto"
                        ? "flex-1 px-4 py-2 text-sm font-semibold text-white bg-blue-600 rounded-full"
                        : "flex-1 px-4 py-2 text-sm font-semibold text-gray-700 bg-gray-100 rounded-full"
                    }
                  >
                    Otomatis
                  </button>
                  <button
                    type="button"
                    onClick={() => this.activationSetMode("manual")}
                    className={
                      this.state.activation_mode === "manual"
                        ? "flex-1 px-4 py-2 text-sm font-semibold text-white bg-blue-600 rounded-full"
                        : "flex-1 px-4 py-2 text-sm font-semibold text-gray-700 bg-gray-100 rounded-full"
                    }
                  >
                    Manual
                  </button>
                </div>

                <form onSubmit={this.generateActivationCodes}>
                  <div className="w-full mt-3">
                    <label className="mb-2 ml-2 text-gray-800 block text-sm">
                      Tahun Ajaran
                    </label>
                    <Select
                      id="TahunAjaranActivation"
                      styles={selectStyles}
                      isClearable
                      options={this.state.data_tahun_ajaran}
                      onChange={this.activationTahunAjaran}
                      placeholder={"Pilih Tahun Ajaran"}
                    />
                  </div>

                  {this.state.activation_mode === "auto" ? (
                    <>
                      <div className="w-full mt-3">
                        <label className="mb-2 ml-2 text-gray-800 block text-sm">
                          Prefix (Opsional)
                        </label>
                        <input
                          type="text"
                          className="w-full pl-4 pr-4 my-0 py-2 rounded-full border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800"
                          placeholder="Masukkan prefix untuk kode aktivasi (opsional)"
                          value={this.state.activation_prefix}
                          onChange={this.activationPrefix}
                        />
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-2 ml-2 text-gray-800 block text-sm">
                          Jumlah Token
                        </label>
                        <input
                          type="number"
                          min="1"
                          className="w-full pl-4 pr-4 my-0 py-2 rounded-full border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800"
                          placeholder="Masukkan jumlah token yang ingin dibuat"
                          value={this.state.activation_jumlah_token}
                          onChange={this.activationJumlahToken}
                          required
                        />
                      </div>
                    </>
                  ) : (
                    <div className="w-full mt-3">
                      <label className="mb-2 ml-2 text-gray-800 block text-sm">
                        Kode Pendaftaran &amp; Token <span className="text-red-500">*</span>
                      </label>
                      <div className="max-h-64 overflow-y-auto pr-1">
                        {this.state.activation_manual_list.map((row, index) => (
                          <div key={index} className="flex gap-2 items-center mb-2">
                            <input
                              type="text"
                              className="w-1/2 pl-4 pr-4 py-2 rounded-full border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800 text-sm"
                              placeholder="Kode Pendaftaran"
                              value={row.kode_pendaftaran}
                              onChange={(e) =>
                                this.activationManualChange(index, "kode_pendaftaran", e.target.value)
                              }
                            />
                            <input
                              type="text"
                              className="w-1/2 pl-4 pr-4 py-2 rounded-full border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800 text-sm"
                              placeholder="Token"
                              value={row.token}
                              onChange={(e) =>
                                this.activationManualChange(index, "token", e.target.value)
                              }
                            />
                            <button
                              type="button"
                              onClick={() => this.activationRemoveManualRow(index)}
                              className="btn-red text-white w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full"
                              disabled={this.state.activation_manual_list.length <= 1}
                            >
                              <i className="bx bx-trash"></i>
                            </button>
                          </div>
                        ))}
                      </div>
                      <button
                        type="button"
                        onClick={this.activationAddManualRow}
                        className="btn-default flex items-center gap-1 px-4 py-2 text-sm rounded-full mt-1"
                      >
                        <i className="bx bx-plus"></i> Tambah Baris
                      </button>
                      <p className="text-xs text-gray-500 ml-2 mt-2">
                        Jumlah token yang akan dibuat: {this.state.activation_manual_list.length}
                      </p>
                    </div>
                  )}

                  <div className="flex items-center justify-between mt-4">
                    <button
                      type="button"
                      className="px-4 py-2 text-gray-600 bg-gray-200 rounded-full hover:bg-gray-300"
                      onClick={this.hideModalGenerateActivation}
                    >
                      Batal
                    </button>
                    <button
                      type="submit"
                      className="px-4 py-2 text-white bg-blue-600 rounded-full hover:bg-blue-700 disabled:opacity-50"
                      disabled={this.state.loading_generate_activation}
                    >
                      {this.state.loading_generate_activation ? (
                        <>
                          <UserButtonLoading color="text-white" />
                          Memproses...
                        </>
                      ) : (
                        "Generate"
                      )}
                    </button>
                  </div>
                </form>
              </Tab>
              <Tab eventKey="import" title="Import Excel">
                <div className="w-full mt-3">
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-3">
                    <p className="text-sm text-gray-700 mb-2">
                      <i className="bx bx-info-circle text-blue-600 mr-1"></i>
                      Download template Excel terlebih dahulu sebelum upload
                    </p>
                    <div className="flex gap-2">
                      <a
                        href="https://s3.schoolmedia.id/02-user-management/format/import-gen-kode-pendaftaran.xlsx"
                        download
                      >
                        <button
                          type="button"
                          className="btn-default flex text-xs px-4 py-2 rounded-full items-center"
                        >
                          <i className="bx bx-download mr-1"></i>
                          Download Template
                        </button>
                      </a>
                      <a
                        href="https://help.schoolmedia.id/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <button
                          type="button"
                          className="btn-default flex text-xs px-4 py-2 rounded-full items-center"
                        >
                          <i className="bx bx-info-circle mr-1"></i>
                          Tutorial
                        </button>
                      </a>
                    </div>
                  </div>

                  {/* Progress Bar untuk Import Activation */}
                  {this.state.is_importing && (
                    <div className="w-full mb-4">
                      <div className="flex justify-between mb-2">
                        <span className="text-sm font-medium text-gray-700">
                          Memproses import... ({this.state.import_current} / {this.state.import_total})
                        </span>
                        <span className="text-sm font-medium text-gray-700">
                          {this.state.import_progress}%
                        </span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-4">
                        <div
                          className="bg-blue-600 h-4 rounded-full transition-all duration-300"
                          style={{ width: `${this.state.import_progress}%` }}
                        ></div>
                      </div>
                    </div>
                  )}

                  <form onSubmit={this.importActivationCodes}>
                    <div className="w-full mt-3">
                      <label className="mb-2 ml-2 text-gray-800 block text-sm">
                        File Excel
                      </label>
                      <input
                        type="file"
                        accept=".xlsx,.xls"
                        className="w-full pl-4 pr-4 my-0 py-2 rounded-full border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800"
                        onChange={this.activationImportFile}
                        required
                        disabled={this.state.is_importing}
                      />
                      <p className="text-xs text-gray-600 ml-2 mt-1">
                        Format file: .xlsx atau .xls
                      </p>
                    </div>
                    <div className="flex items-center justify-between mt-4">
                      <button
                        type="button"
                        className="px-4 py-2 text-gray-600 bg-gray-200 rounded-full hover:bg-gray-300"
                        onClick={this.hideModalGenerateActivation}
                        disabled={this.state.is_importing}
                      >
                        Batal
                      </button>
                      <button
                        type="submit"
                        className="px-4 py-2 text-white bg-blue-600 rounded-full hover:bg-blue-700 disabled:opacity-50"
                        disabled={this.state.loading_import_activation || this.state.is_importing}
                      >
                        {this.state.loading_import_activation || this.state.is_importing ? (
                          <>
                            <UserButtonLoading color="text-white" />
                            Memproses...
                          </>
                        ) : (
                          <>
                            <i className="bx bx-upload mr-1"></i>
                            Upload & Generate
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </Tab>
            </Tabs>
          </Modal.Body>
        </Modal>

        {/* modal tambah - Premium Design */}
        <Modal
          show={this.state.modal_tambah}
          onHide={this.hideModalTambah}
          size="lg"
          centered
          contentClassName="rounded-xl border-0 shadow-2xl overflow-hidden"
        >
          <div className="bg-white">
            {/* Premium Gradient Header */}
            <div className="modal-header-gradient-blue-purple px-6 py-5">
              <div className="flex items-center">
                <div className="w-12 h-12 rounded-xl bg-white/20 backdrop-blur flex items-center justify-center mr-4">
                  <i className="bx bxs-user-plus text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-white">Tambah Siswa Baru</h4>
                  <p className="text-blue-100 text-sm mt-0.5">Lengkapi data siswa dengan teliti</p>
                </div>
              </div>
            </div>

            <Modal.Body className="p-6">
              <form onSubmit={this.create}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Left Column: Academic & Identity */}
                  <div className="space-y-4">
                    <div className="bg-blue-50/50 p-4 rounded-xl border border-blue-100/50">
                      <h5 className="text-sm font-bold text-blue-800 mb-4 flex items-center">
                        <i className='bx bxs-school mr-2'></i>
                        Data Akademik
                      </h5>

                      <div className="mb-4">
                        <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                          Tahun Ajaran Masuk <span className="text-red-500">*</span>
                        </label>
                        <Select
                          id="TahunAjaran"
                          styles={selectStyles}
                          isClearable
                          className="text-sm"
                          options={this.state.data_tahun_ajaran}
                          onChange={this.createTahunAjaran}
                          placeholder={"Pilih Tahun Ajaran"}
                        />
                      </div>

                      <div>
                        <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                          No Pendaftaran / NISN <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-white text-gray-800 text-sm"
                          placeholder="Contoh: 0012345678"
                          onChange={this.nisn}
                        />
                      </div>
                    </div>

                    <div className="bg-gray-50 p-4 rounded-xl border border-gray-100">
                      <h5 className="text-sm font-bold text-gray-700 mb-4 flex items-center">
                        <i className='bx bxs-user-detail mr-2'></i>
                        Data Diri
                      </h5>

                      <div className="mb-4">
                        <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                          Nama Lengkap <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-white text-gray-800 text-sm font-medium"
                          placeholder="Nama Lengkap Siswa"
                          onChange={this.nama}
                        />
                      </div>

                      <div className="mb-4">
                        <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                          Jenis Kelamin <span className="text-red-500">*</span>
                        </label>
                        <div className="flex space-x-4 bg-white p-2 rounded-lg border border-gray-200">
                          <label className="flex items-center cursor-pointer p-2 rounded hover:bg-gray-50 flex-1 justify-center transition-colors">
                            <input
                              type="radio"
                              className="form-radio text-blue-600 h-4 w-4"
                              value="1"
                              name="jenis_kelamin_add"
                              onChange={this.jenis_kelamin}
                            />
                            <span className="ml-2 text-sm text-gray-700 font-medium">Laki-laki</span>
                          </label>
                          <div className="w-px bg-gray-200 h-6 self-center"></div>
                          <label className="flex items-center cursor-pointer p-2 rounded hover:bg-gray-50 flex-1 justify-center transition-colors">
                            <input
                              type="radio"
                              className="form-radio text-pink-500 h-4 w-4"
                              value="0"
                              name="jenis_kelamin_add"
                              onChange={this.jenis_kelamin}
                            />
                            <span className="ml-2 text-sm text-gray-700 font-medium">Perempuan</span>
                          </label>
                        </div>
                      </div>

                      <div>
                        <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                          Tanggal Lahir <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="date"
                          name="birthday"
                          className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-white text-gray-800 text-sm"
                          onChange={this.tanggal_lahir}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Right Column: Account & Contact */}
                  <div className="space-y-4">
                    <div className="bg-yellow-50/50 p-4 rounded-xl border border-yellow-100/50 h-full">
                      <h5 className="text-sm font-bold text-yellow-800 mb-4 flex items-center">
                        <i className='bx bxs-lock-alt mr-2'></i>
                        Akun & Kontak
                      </h5>

                      <div className="mb-4">
                        <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                          Username
                        </label>
                        <div className="relative">
                          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                            <i className="bx bx-user text-lg"></i>
                          </span>
                          <input
                            type="text"
                            className={`w-full pl-10 pr-10 py-2.5 rounded-lg border ${this.state.usernameAvailable === false
                              ? 'border-red-400 focus:border-red-500 focus:ring-red-100'
                              : this.state.usernameAvailable === true
                                ? 'border-green-400 focus:border-green-500 focus:ring-green-100'
                                : 'border-gray-300 focus:border-blue-500 focus:ring-blue-100'
                              } focus:ring-2 transition-all duration-200 bg-white text-gray-800 text-sm`}
                            placeholder="Masukkan Username"
                            onChange={(e) => {
                              this.username(e);
                              this.checkUsernameAvailability(e.target.value);
                            }}
                          />
                          {this.state.checkingUsername && (
                            <span className="absolute right-3 top-1/2 transform -translate-y-1/2">
                              <i className="bx bx-loader-alt bx-spin text-gray-400"></i>
                            </span>
                          )}
                          {!this.state.checkingUsername && this.state.usernameAvailable === true && (
                            <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-green-500">
                              <i className="bx bx-check-circle text-lg"></i>
                            </span>
                          )}
                          {!this.state.checkingUsername && this.state.usernameAvailable === false && (
                            <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-red-500">
                              <i className="bx bx-x-circle text-lg"></i>
                            </span>
                          )}
                        </div>
                        {this.state.usernameAvailable === false && (
                          <p className="text-xs text-red-500 mt-1 ml-1">Username sudah digunakan</p>
                        )}
                        {this.state.usernameAvailable === true && (
                          <p className="text-xs text-green-500 mt-1 ml-1">Username tersedia</p>
                        )}
                        {!this.state.usernameAvailable && (
                          <p className="text-xs text-gray-400 mt-1 ml-1">Huruf kecil, tanpa spasi</p>
                        )}
                      </div>

                      <div className="mb-4">
                        <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                          Email
                        </label>
                        <div className="relative">
                          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                            <i className="bx bx-envelope text-lg"></i>
                          </span>
                          <input
                            type="email"
                            className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-white text-gray-800 text-sm"
                            placeholder="contoh@email.com"
                            onChange={this.email}
                          />
                        </div>
                      </div>

                      <div className="mb-4">
                        <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                          Password
                        </label>
                        <div className="relative">
                          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                            <i className="bx bx-lock text-lg"></i>
                          </span>
                          <input
                            type={this.state.showPasswordAdd ? "text" : "password"}
                            className="w-full pl-10 pr-10 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-white text-gray-800 text-sm"
                            placeholder="Buat password aman"
                            value={this.state.password_create || ''}
                            onChange={(e) => {
                              this.setState({ password_create: e.target.value });
                              this.password(e);
                            }}
                          />
                          <button
                            type="button"
                            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                            onClick={() => this.setState({ showPasswordAdd: !this.state.showPasswordAdd })}
                          >
                            <i className={`bx ${this.state.showPasswordAdd ? 'bx-hide' : 'bx-show'} text-lg`}></i>
                          </button>
                        </div>
                        {/* Password Strength Indicator */}
                        {this.state.password_create && (
                          <div className="mt-2">
                            <div className="flex gap-1 mb-1">
                              <div className={`h-1 flex-1 rounded ${this.state.password_create.length >= 1
                                ? (this.state.password_create.length >= 8
                                  ? (this.state.password_create.match(/[A-Z]/) && this.state.password_create.match(/[0-9]/)
                                    ? 'bg-green-500'
                                    : 'bg-yellow-500')
                                  : 'bg-red-500')
                                : 'bg-gray-200'
                                }`}></div>
                              <div className={`h-1 flex-1 rounded ${this.state.password_create.length >= 6
                                ? (this.state.password_create.match(/[A-Z]/) || this.state.password_create.match(/[0-9]/)
                                  ? 'bg-yellow-500'
                                  : 'bg-red-500')
                                : 'bg-gray-200'
                                }`}></div>
                              <div className={`h-1 flex-1 rounded ${this.state.password_create.length >= 8 &&
                                this.state.password_create.match(/[A-Z]/) &&
                                this.state.password_create.match(/[0-9]/)
                                ? 'bg-green-500'
                                : 'bg-gray-200'
                                }`}></div>
                            </div>
                            <p className={`text-xs ${this.state.password_create.length >= 8 &&
                              this.state.password_create.match(/[A-Z]/) &&
                              this.state.password_create.match(/[0-9]/)
                              ? 'text-green-600'
                              : this.state.password_create.length >= 6
                                ? 'text-yellow-600'
                                : 'text-red-500'
                              }`}>
                              {this.state.password_create.length >= 8 &&
                                this.state.password_create.match(/[A-Z]/) &&
                                this.state.password_create.match(/[0-9]/)
                                ? '✓ Password kuat'
                                : this.state.password_create.length >= 6
                                  ? '◐ Password sedang'
                                  : '✗ Password lemah (min. 8 karakter, huruf besar & angka)'}
                            </p>
                          </div>
                        )}
                        {!this.state.password_create && (
                          <p className="text-xs text-gray-400 mt-1 ml-1">Min. 8 karakter dengan huruf besar dan angka</p>
                        )}
                      </div>

                      <div>
                        <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                          No. Handphone <span className="text-gray-400 font-normal normal-case">(Opsional)</span>
                        </label>
                        <div className="relative">
                          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                            <i className="bx bx-phone text-lg"></i>
                          </span>
                          <input
                            type="text"
                            className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-white text-gray-800 text-sm"
                            placeholder="08xxxxxxxxxx"
                            onChange={this.no_handphone}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100">
                  <button
                    type="button"
                    className="px-6 py-2.5 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-full font-medium transition-colors text-sm"
                    onClick={this.hideModalTambah}
                  >
                    Batal
                  </button>
                  <button
                    type="submit"
                    disabled={this.state.simpleLoading}
                    className="px-6 py-2.5 text-white btn-gradient-blue rounded-full font-medium transition-all text-sm flex items-center disabled:opacity-50"
                  >
                    {this.state.simpleLoading ? (
                      <>
                        <UserButtonLoading color="text-white" />
                        <span className="ml-2">Menyimpan...</span>
                      </>
                    ) : (
                      <>
                        <i className="bx bx-save mr-2"></i>
                        Simpan Data
                      </>
                    )}
                  </button>
                </div>
              </form>
            </Modal.Body>
          </div>
        </Modal>

        {/* modal edit */}
        {/* modal edit */}
        <Modal
          show={this.state.modal_edit}
          onHide={this.hideModalEdit}
          size="lg"
          centered
          contentClassName="rounded-xl border-0 shadow-2xl overflow-hidden"
        >
          <div className="bg-white">
            {/* Premium Gradient Header */}
            <div className="modal-header-gradient-blue-purple px-6 py-5">
              <div className="flex items-center">
                <div className="w-12 h-12 rounded-xl bg-white/20 backdrop-blur flex items-center justify-center mr-4">
                  <i className="bx bxs-edit text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-white">Edit Data Siswa</h4>
                  <p className="text-blue-100 text-sm mt-0.5">Perbarui informasi siswa dengan teliti</p>
                </div>
              </div>
            </div>

            {this.state.loading_edit ? (
              <UserEditSkeleton />
            ) : (
              <Modal.Body className="p-6">
                <form onSubmit={this.update}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Left Column: Academic & Identity */}
                    <div className="space-y-4">
                      <div className="bg-blue-50/50 p-4 rounded-xl border border-blue-100/50">
                        <h5 className="text-sm font-bold text-blue-800 mb-4 flex items-center">
                          <i className='bx bxs-school mr-2'></i>
                          Akademik
                        </h5>

                        <div className="mb-4">
                          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                            Tahun Ajaran Masuk
                          </label>
                          <Select
                            id="TahunAjaran"
                            styles={selectStyles}
                            isClearable
                            className="text-sm"
                            defaultValue={
                              this.state.tahun_ajaran_create != ""
                                ? {
                                  value: this.state.tahun_ajaran_create,
                                  label: this.state.tahun_ajaran_create,
                                }
                                : ""
                            }
                            options={this.state.data_tahun_ajaran}
                            onChange={this.createTahunAjaran}
                            placeholder={"Pilih Tahun Ajaran"}
                          />
                        </div>

                        <div>
                          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                            No Pendaftaran / NISN
                          </label>
                          <input
                            type="text"
                            className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-white text-gray-800 text-sm"
                            placeholder="Contoh: 0012345678"
                            defaultValue={this.state.nisn != "" ? this.state.nisn : ""}
                            onChange={this.nisn}
                          />
                        </div>
                      </div>

                      <div className="bg-gray-50 p-4 rounded-xl border border-gray-100">
                        <h5 className="text-sm font-bold text-gray-700 mb-4 flex items-center">
                          <i className='bx bxs-user-detail mr-2'></i>
                          Data Diri
                        </h5>

                        <div className="mb-4">
                          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                            Nama Lengkap
                          </label>
                          <input
                            type="text"
                            className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-white text-gray-800 text-sm font-medium"
                            placeholder="Nama Lengkap Siswa"
                            defaultValue={this.state.nama != "" ? this.state.nama : ""}
                            onChange={this.nama}
                          />
                        </div>

                        <div className="mb-4">
                          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                            Jenis Kelamin
                          </label>
                          <div className="flex space-x-4 bg-white p-2 rounded-lg border border-gray-200">
                            <label className="flex items-center cursor-pointer p-2 rounded hover:bg-gray-50 flex-1 justify-center transition-colors">
                              <input
                                type="radio"
                                className="form-radio text-blue-600 h-4 w-4"
                                value="1"
                                name="jenis_kelamin"
                                onChange={this.jenis_kelamin}
                                defaultChecked={this.state.jenis_kelamin == "1"}
                              />
                              <span className="ml-2 text-sm text-gray-700 font-medium">Laki-laki</span>
                            </label>
                            <div className="w-px bg-gray-200 h-6 self-center"></div>
                            <label className="flex items-center cursor-pointer p-2 rounded hover:bg-gray-50 flex-1 justify-center transition-colors">
                              <input
                                type="radio"
                                className="form-radio text-pink-500 h-4 w-4"
                                value="0"
                                name="jenis_kelamin"
                                onChange={this.jenis_kelamin}
                                defaultChecked={this.state.jenis_kelamin == "0"}
                              />
                              <span className="ml-2 text-sm text-gray-700 font-medium">Perempuan</span>
                            </label>
                          </div>
                        </div>

                        <div>
                          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                            Tanggal Lahir
                          </label>
                          <input
                            type="date"
                            name="birthday"
                            className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-white text-gray-800 text-sm"
                            defaultValue={
                              this.state.tanggal_lahir != ""
                                ? this.state.tanggal_lahir
                                : ""
                            }
                            onChange={this.tanggal_lahir}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Right Column: Account & Contact */}
                    <div className="space-y-4">
                      <div className="bg-yellow-50/50 p-4 rounded-xl border border-yellow-100/50 h-full">
                        <h5 className="text-sm font-bold text-yellow-800 mb-4 flex items-center">
                          <i className='bx bxs-lock-alt mr-2'></i>
                          Akun & Kontak
                        </h5>

                        <div className="mb-4">
                          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                            Username
                          </label>
                          <div className="relative">
                            <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <i className='bx bx-user text-gray-400'></i>
                            </span>
                            <input
                              type="text"
                              className={`w-full pl-10 pr-10 py-2.5 rounded-lg border transition-all duration-200 bg-white text-gray-800 text-sm ${this.state.usernameAvailable === true
                                ? 'border-green-400 focus:border-green-500 focus:ring-2 focus:ring-green-100'
                                : this.state.usernameAvailable === false
                                  ? 'border-red-400 focus:border-red-500 focus:ring-2 focus:ring-red-100'
                                  : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                                }`}
                              placeholder="Username"
                              value={this.state.username || ""}
                              onChange={(e) => {
                                this.username(e);
                                this.checkUsernameAvailability(e.target.value);
                              }}
                            />
                            <span className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                              {this.state.checkingUsername && (
                                <i className='bx bx-loader-alt bx-spin text-blue-500'></i>
                              )}
                              {!this.state.checkingUsername && this.state.usernameAvailable === true && (
                                <i className='bx bx-check-circle text-green-500'></i>
                              )}
                              {!this.state.checkingUsername && this.state.usernameAvailable === false && (
                                <i className='bx bx-x-circle text-red-500'></i>
                              )}
                            </span>
                          </div>
                          {this.state.usernameAvailable === false && this.state.usernameRecommendations.length > 0 && (
                            <div className="mt-2">
                              <p className="text-xs text-gray-500 mb-1">Username tidak tersedia. Coba salah satu:</p>
                              <div className="flex flex-wrap gap-1">
                                {this.state.usernameRecommendations.map((rec, idx) => (
                                  <button
                                    key={idx}
                                    type="button"
                                    className="text-xs px-2 py-1 bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 transition-colors border border-blue-200"
                                    onClick={() => this.selectUsernameRecommendation(rec)}
                                  >
                                    {rec}
                                  </button>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="mb-4">
                          <div className="flex items-center justify-between mb-2">
                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider">
                              Email
                            </label>
                            {this.state.userStatus === 'Active' && (
                              <span className="text-[10px] px-2 py-0.5 bg-gray-100 text-gray-500 rounded-full font-medium flex items-center">
                                <i className='bx bx-lock-alt mr-1'></i> Terkunci
                              </span>
                            )}
                          </div>
                          <div className="relative">
                            <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <i className={`bx bx-envelope ${this.state.userStatus === 'Active' ? 'text-gray-300' : 'text-gray-400'}`}></i>
                            </span>
                            <input
                              type="email"
                              className={`w-full pl-10 pr-4 py-2.5 rounded-lg border transition-all duration-200 text-sm ${this.state.userStatus === 'Active'
                                ? 'border-gray-200 bg-gray-50 text-gray-400 cursor-not-allowed'
                                : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 bg-white text-gray-800'
                                }`}
                              placeholder="email@sekolah.sch.id"
                              value={this.state.email || ""}
                              onChange={this.email}
                              disabled={this.state.userStatus === 'Active'}
                            />
                            {this.state.userStatus === 'Active' && (
                              <span className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                <i className='bx bx-lock text-gray-300'></i>
                              </span>
                            )}
                          </div>
                          {this.state.userStatus === 'Active' && (
                            <p className="text-[10px] text-gray-400 mt-1 italic">
                              Email tidak dapat diubah karena akun sudah aktif
                            </p>
                          )}
                        </div>

                        <div className="mb-4">
                          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                            No Handphone / WA
                          </label>
                          <div className="relative">
                            <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <i className='bx bx-phone text-gray-400'></i>
                            </span>
                            <input
                              type="text"
                              className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-white text-gray-800 text-sm"
                              placeholder="08xxxxxxxxxx"
                              defaultValue={this.state.no_handphone}
                              onChange={this.no_handphone}
                            />
                          </div>
                        </div>

                        <div className="pt-4 border-t border-yellow-200/50 mt-6">
                          <div className="flex items-center mb-2">
                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mr-2">
                              Ubah Password
                            </label>
                            <span className="text-[10px] px-2 py-0.5 bg-yellow-100 text-yellow-700 rounded-full font-medium">Opsional</span>
                          </div>
                          <p className="text-xs text-gray-400 mb-2 italic">Kosongkan jika tidak ingin mengubah password</p>
                          <div className="relative">
                            <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <i className='bx bx-key text-gray-400'></i>
                            </span>
                            <input
                              type={this.state.showPassword ? "text" : "password"}
                              className="w-full pl-10 pr-10 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-white text-gray-800 text-sm"
                              placeholder="Password Baru"
                              defaultValue=""
                              onChange={this.password}
                            />
                            <button
                              type="button"
                              className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 focus:outline-none"
                              onClick={this.togglePasswordVisibility}
                            >
                              {this.state.showPassword ? (
                                <i className="bx bx-hide text-lg"></i>
                              ) : (
                                <i className="bx bx-show text-lg"></i>
                              )}
                            </button>
                          </div>
                          {this.state.passwordStrengthText && (
                            <div className="mt-1 flex items-center justify-between">
                              <span className="text-[10px] text-gray-400">
                                Kekuatan Password:
                              </span>
                              <span
                                className={`text-[10px] font-bold ${this.state.passwordStrength}`}
                              >
                                {this.state.passwordStrengthText}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Hidden submit button to allow form submission on enter */}
                  <input type="submit" className="hidden" />
                </form>
              </Modal.Body>
            )}

            <Modal.Footer className="border-t border-gray-100 bg-gray-50/50 px-6 py-4 rounded-b-xl">
              <button
                className="px-6 py-2.5 rounded-lg text-gray-600 hover:text-gray-800 font-medium text-sm transition-colors hover:bg-gray-100 mr-2"
                onClick={this.hideModalEdit}
                type="button"
              >
                Batal
              </button>
              <button
                className={`px-8 py-2.5 rounded-lg text-white font-medium text-sm transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center ${this.state.simpleLoading || this.state.checkingUsername
                  ? "bg-gray-400 cursor-not-allowed"
                  : this.state.usernameAvailable === false
                    ? "bg-red-400 cursor-not-allowed"
                    : "bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800"
                  }`}
                style={
                  !(this.state.simpleLoading || this.state.checkingUsername || this.state.usernameAvailable === false)
                    ? {
                      background: '#2563eb', // Solid Blue 600 - Guaranteed to work
                      color: 'white'
                    }
                    : {}
                }
                onClick={this.update}
                disabled={this.state.simpleLoading || this.state.checkingUsername || this.state.usernameAvailable === false}
                type="button"
                title={
                  this.state.usernameAvailable === false
                    ? "Username tidak tersedia. Silakan pilih username lain."
                    : this.state.checkingUsername
                      ? "Sedang memeriksa username..."
                      : "Simpan perubahan data"
                }
              >
                {this.state.simpleLoading ? (
                  <>
                    <i className="bx bx-loader-alt animate-spin mr-2"></i>
                    Menyimpan...
                  </>
                ) : this.state.checkingUsername ? (
                  <>
                    <i className="bx bx-loader-alt animate-spin mr-2"></i>
                    Memeriksa Username...
                  </>
                ) : this.state.usernameAvailable === false ? (
                  <>
                    <i className="bx bx-error-circle mr-2"></i>
                    Username Tidak Tersedia
                  </>
                ) : (
                  <>
                    <i className="bx bx-save mr-2"></i>
                    Simpan Perubahan
                  </>
                )}
              </button>
            </Modal.Footer>
          </div>
        </Modal>

        {/* modal detail */}
        <Modal
          size="lg"
          show={this.state.modal_detail}
          onHide={this.hideModalDetail}
        >
          {this.state.loading_detail ? (
            <UserDetailSkeleton />
          ) : (
            <Modal.Body className="">
              <div className="flex flex-col w-full">
                <div
                  className={`w-full rounded-lg bg-1 mb-10`}
                  style={{ height: "10rem" }}
                >
                  <div
                    className="overflow-hidden rounded-lg"
                    style={{ height: "10rem" }}
                  >
                    <img
                      className=""
                      src={
                        this.state.data_detail.foto_sampul
                          ? `https://static.schoolmedia.id/public/assets/socmed/SI/cover/${this.state.data_detail.foto_sampul}`
                          : `${conf.uri_frontend}assets/img/cover-unavailable.svg`
                      }
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div
                    className="flex flex-row px-4 pb-4 rounded-lg items-center w-full bg-transparent-grad relative"
                    style={{ bottom: "10rem", paddingTop: "6rem" }}
                  >
                    <img
                      className="rounded-full border-4 border-white shadow-xl"
                      style={{
                        width: "6rem",
                        height: "6rem",
                        objectFit: "cover",
                      }}
                      src={
                        this.state.data_detail.foto_profil
                          ? `${conf.uri_s3}/00-universal/${this.state.data_detail.website}/SI/${this.state.data_detail.foto_profil}`
                          : `${conf.uri_frontend}assets/img/profile-unavailable.png`
                      }
                    />
                    <h1 className="text-xl font-bold text-gray-800 ml-2">
                      {this.state.data_detail.nama
                        ? this.state.data_detail.nama
                        : "-"}
                    </h1>
                  </div>
                </div>
              </div>
              <Tabs
                defaultActiveKey="detail1"
                id="uncontrolled-tab-example"
                className="mt-4"
              >
                <Tab eventKey="detail1" title="Detail 1">
                  <div className="show-grid flex">
                    <div className="sm:w-full w-1/2">
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Token
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.token
                            ? this.state.data_detail.token
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No Pendaftaran
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.kode_pendaftaran
                            ? this.state.data_detail.kode_pendaftaran
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Jenis Kelamin
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.jenis_kelamin != null
                            ? this.state.data_detail.jenis_kelamin != 1
                              ? "Perempuan"
                              : "Laki - laki"
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Tempat Lahir
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.tempat_lahir
                            ? this.state.data_detail.tempat_lahir
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Tanggal Lahir
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.tanggal_lahir
                            ? this.state.data_detail.tanggal_lahir
                            : "-"}
                        </p>
                      </div>
                    </div>
                    <div className="sm:w-full w-1/2">
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Agama
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.agama
                            ? this.state.data_detail.agama
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No. Handphone
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.no_handphone
                            ? this.state.data_detail.no_handphone
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Golongan Darah
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.golongan_darah
                            ? this.state.data_detail.golongan_darah
                            : "-"}
                        </p>
                      </div>
                      {/* <div className="w-full mt-3">
                      <label className="mb-1 ml-2 text-gray-700 block text-xs">Agama</label>
                      <p className="mb-2 ml-2 text-gray-900 block text-base">{this.state.data_detail.pendidikan_terakhir ? ( this.state.data_detail.pendidikan_terakhir ) : ('-')}</p>
                    </div>  */}
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Motto
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.motto
                            ? this.state.data_detail.motto
                            : "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="detail2" title="Detail 2">
                  <div className="show-grid flex">
                    <div className="sm:w-full w-1/3">
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No. KK
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.kk
                            ? this.state.data_detail.kk
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No. NIK
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.nik
                            ? this.state.data_detail.nik
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No. NPWP
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.npwp
                            ? this.state.data_detail.npwp
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No. Paspor
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.paspor
                            ? this.state.data_detail.paspor
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Negara
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.negara
                            ? this.state.data_detail.negara
                            : "-"}
                        </p>
                      </div>
                    </div>
                    <div className="sm:w-full w-1/3">
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-900 block text-sm">
                          Alamat Tinggal
                        </label>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Provinsi
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.provinsi_tinggal
                              ? this.state.data_detail.provinsi_tinggal
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kabupaten / Kota
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kabupaten_tinggal
                              ? this.state.data_detail.kabupaten_tinggal
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kecamatan
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kecamatan_tinggal
                              ? this.state.data_detail.kecamatan_tinggal
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Desa
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.desa_tinggal
                              ? this.state.data_detail.desa_tinggal
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kode Pos
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kode_pos__tinggal
                              ? this.state.data_detail.kode_pos__tinggal
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            RW / RT
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.rw_tinggal
                              ? this.state.data_detail.rw_tinggal
                              : "-"}{" "}
                            /
                            {this.state.data_detail.rt_tinggal
                              ? ` ${this.state.data_detail.rt_tinggal}`
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Alamat
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.alamat_tinggal
                              ? this.state.data_detail.alamat_tinggal
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="sm:w-full w-1/3">
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-900 block text-sm">
                          Alamat Domisili
                        </label>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Provinsi
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.provinsi_domisili
                              ? this.state.data_detail.provinsi_domisili
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kabupaten / Kota
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kabupaten_domisili
                              ? this.state.data_detail.kabupaten_domisili
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kecamatan
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kecamatan_domisili
                              ? this.state.data_detail.kecamatan_domisili
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Desa
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.desa_domisili
                              ? this.state.data_detail.desa_domisili
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kode Pos
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kode_pos__domisili
                              ? this.state.data_detail.kode_pos__domisili
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            RW / RT
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.rw_domisili
                              ? this.state.data_detail.rw_domisili
                              : "-"}{" "}
                            /
                            {this.state.data_detail.rt_domisili
                              ? ` ${this.state.data_detail.rt_domisili}`
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Alamat
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.alamat_domisili
                              ? this.state.data_detail.alamat_domisili
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
              {/* <div className="show-grid flex mt-4 border-t">
                <div className="sm:w-full w-1/2 px-2">
                  <p className="my-2 ml-2 text-gray-900 block text-sm font-bold">
                    Foto KTP
                  </p>
                  <img
                    className="w-full"
                    style={{
                      height: "300px",
                      objectFit: "none",
                      objectPosition: "center",
                    }}
                    src={
                      this.state.data_detail.foto_ktp
                        ? `https://static.schoolmedia.id/public/assets/socmed/SI/ktp/${this.state.data_detail.foto_ktp}`
                        : `${conf.uri_frontend}assets/img/img-unavailable.png`
                    }
                  />
                </div>
                <div className="sm:w-full w-1/2 px-2">
                  <p className="my-2 ml-2 text-gray-900 block text-sm font-bold">
                    Foto KTP & Wajah
                  </p>
                  <img
                    className="w-full"
                    style={{
                      height: "300px",
                      objectFit: "none",
                      objectPosition: "center",
                    }}
                    src={
                      this.state.data_detail.foto_ktp_dan_wajah
                        ? `https://static.schoolmedia.id/public/assets/socmed/SI/ktp-face/${this.state.data_detail.foto_ktp_dan_wajah}`
                        : `${conf.uri_frontend}assets/img/img-unavailable.png`
                    }
                  />
                </div>
              </div>
              <div className="w-full">
                <div className="rounded-lg w-1/2 mx-auto">
                  <p className="my-2 ml-2 text-gray-900 block text-sm font-bold">
                    Foto Doc. Pendukung
                  </p>
                  <img
                    className="w-full"
                    style={{
                      height: "300px",
                      objectFit: "none",
                      objectPosition: "center",
                    }}
                    src={
                      this.state.data_detail.foto_doc_pendukung
                        ? `https://static.schoolmedia.id/public/assets/socmed/SI/img-support/${this.state.data_detail.foto_doc_pendukung}`
                        : `${conf.uri_frontend}assets/img/img-unavailable.png`
                    }
                  />
                </div>
              </div> */}
            </Modal.Body>
          )}
          <Modal.Footer>
            <button
              className="btn-default mx-1 px-4 py-2 justify-center font-medium rounded-full text-gray-800 items-center text-sm"
              onClick={this.hideModalDetail}
            >
              Tutup
            </button>
          </Modal.Footer>
        </Modal>

        {/* Cetak Modal */}
        <Modal
          size="lg"
          show={this.state.modal_cetak}
          onHide={this.hideModalCetak}
        >
          <Modal.Header>Cetak Siswa</Modal.Header>
          <Modal.Body>
            <div className="flex justify-between items-center w-full px-2 py-2">
              <div className="w-1/2 flex items-center justify-start">
                <input
                  type="search"
                  className="w-2/3 pl-4 pr-1 py-1 rounded-full  border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800 text-sm "
                  placeholder="Cari nama"
                  id="search"
                  onChange={(event) => {
                    this.setState(
                      {
                        queryToken: `&search=${event.target.value}
                                  &paginate=${this.state.mode_show_token}`,
                        searchToken: event.target.value,
                      },
                      function () {
                        this.dtt.loading();
                        this.dtt.fetchEntities(this.state.queryToken);
                      }
                    );
                  }}
                />
                <div className="ml-2 w-1/3 pl-3 pr-3 py-1 rounded-full flex justify-between items-center  border border-gray-500 focus:outline-none focus:shadow-outline  text-sm ">
                  <span className="text-sm text-gray-800">Pilih semua</span>
                  <input
                    type="checkbox"
                    className="select-all"
                    onChange={this.pilihSemua.bind(this)}
                  />
                </div>
              </div>
              <div className="w-1/2 text-right flex items-center">
                <div className="w-full ml-1 flex flex-wrap text-right items-center justify-end">
                  <div className="mr-0 flex text-right items-center">
                    <span className="text-sm  ml-auto text-gray-800 px-1 mb-2">
                      Tampilkan :{" "}
                    </span>
                    <button
                      onClick={this.showModeToken.bind(this, 10)}
                      className={`${this.state.mode_show_token == 10
                        ? `btn-schoolmedia`
                        : `bg-gray-400`
                        } px-1 flex items-center rounded-full text-white py-1 text-xs mr-1`}
                    >
                      10
                    </button>
                    <button
                      onClick={this.showModeToken.bind(this, 50)}
                      className={`${this.state.mode_show_token == 50
                        ? `btn-schoolmedia`
                        : `bg-gray-400`
                        } px-1 flex items-center rounded-full text-white py-1 text-xs mr-1`}
                    >
                      50
                    </button>
                    <button
                      onClick={this.showModeToken.bind(this, 100)}
                      className={`${this.state.mode_show_token == 100
                        ? `btn-schoolmedia`
                        : `bg-gray-400`
                        } px-1 flex items-center rounded-full text-white py-1 text-xs mr-1`}
                    >
                      100
                    </button>
                    <button
                      onClick={this.showModeToken.bind(this, 200)}
                      className={`${this.state.mode_show_token == 200
                        ? `btn-schoolmedia`
                        : `bg-gray-400`
                        } px-1 flex items-center rounded-full text-white py-1 text-xs mr-1`}
                    >
                      200
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div id="cetakToken">
              {this.showTableToken()}
              {this.state.loading_saveprint ? (
                <button
                  className="btn-schoolmedia px-4 flex items-center rounded-full text-white mt-2 py-2 text-sm"
                  disabled={this.state.loading_saveprint == true ? true : false}
                >
                  <UserButtonLoading />
                </button>
              ) : (
                <input
                  type="button"
                  onClick={this.printToken.bind(this)}
                  className="btn-schoolmedia px-4 flex items-center rounded-full text-white mt-2 py-2 text-sm"
                  value="Simpan"
                />
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn-default mx-1 px-4 py-2 justify-center font-medium rounded-full text-gray-800 items-center text-sm"
              onClick={this.hideModalCetak}
            >
              Tutup
            </button>
          </Modal.Footer>
        </Modal>

        {/* Upload / Import */}
        <Modal
          size="lg"
          show={this.state.modal_import}
          onHide={this.hideModalImport}
        >
          <Modal.Header>Upload Data</Modal.Header>
          <Modal.Body>
            <div className="w-full mt-3 flex flex-row items-center">
              <label className="mb-2 ml-2 text-gray-800 block text-sm mr-2">
                Download template excelnya dulu sebelum upload data
              </label>
              <a
                href={`${conf.uri_s3}/02-user-management/format/contoh-import-siswa.xlsx`}
                download
              >
                <button className="btn-default flex text-xs px-4 py-2 mr-1 rounded-full items-center">
                  Download
                  <i className="bx bx-download ml-1"></i>
                </button>
              </a>
              <a
                href="https://help.schoolmedia.id/"
                target="_blank"
                rel="noreferrer"
              >
                <button className="btn-default flex text-xs px-4 py-2 mr-1 rounded-full items-center">
                  Tutorial Upload
                  <i className="bx bx-info-circle ml-1"></i>
                </button>
              </a>
            </div>
            <form onSubmit={this.import}>
              <div className="w-full mt-3">
                <label className="mb-2 ml-2 text-gray-800 block text-sm">
                  File Excel
                </label>
                <input
                  type="file"
                  className="w-full pl-4 pr-4 my-0 py-2 rounded-full  border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800 "
                  onChange={this.import_file}
                />
              </div>
              <input
                type="submit"
                className={
                  this.state.simpleLoading
                    ? "btn-disabled px-4 flex items-center rounded-full py-2 mt-2 text-sm"
                    : "btn-schoolmedia px-4 flex items-center rounded-full text-white py-2 mt-2 text-sm"
                }
                value={this.state.simpleLoading ? "Tunggu..." : "Simpan"}
                disabled={this.state.simpleLoading ? true : false}
              />
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn-default mx-1 px-4 py-2 justify-center font-medium rounded-full text-gray-800 items-center text-sm"
              onClick={this.hideModalImport}
            >
              Tutup
            </button>
          </Modal.Footer>
        </Modal>

        {/* Preview Import */}
        <Modal
          size="lg"
          show={this.state.modal_preview_import}
          onHide={this.hideModalPrevImport}
        >
          <Modal.Header>Preview Import</Modal.Header>
          <Modal.Body>
            {/* Progress Bar */}
            {this.state.is_importing && (
              <div className="w-full mb-4">
                <div className="flex justify-between mb-2">
                  <span className="text-sm font-medium text-gray-700">
                    Memproses data...
                  </span>
                  <span className="text-sm font-medium text-gray-700">
                    {this.state.import_current} / {this.state.import_total} ({this.state.import_progress}%)
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-4">
                  <div
                    className="bg-blue-600 h-4 rounded-full transition-all duration-300"
                    style={{ width: `${this.state.import_progress}%` }}
                  ></div>
                </div>
              </div>
            )}

            <form onSubmit={this.simpanImport}>
              <div className="table-responsive">
                <table className="table table-bordered font-thin text-sm">
                  <thead className="text-center">
                    <th>TAHUN AJARAN MASUK</th>
                    <th>KODE PENDAFTARAN</th>
                    <th>NAMA</th>
                    <th>JENIS KELAMIN</th>
                    <th>TANGGAL LAHIR</th>
                    <th>USERNAME</th>
                    <th>EMAIL</th>
                    <th>PASSWORD</th>
                    <th>NAMA FILE FOTO PROFIL</th>
                  </thead>
                  <tbody>
                    {this.state.data_preview.map((person, index) => (
                      <tr className={person.duplicated ? 'table-danger' : ''} key={index}>
                        <td>
                          <div className="text-sm">{person.tahun_ajaran}</div>
                        </td>
                        <td>
                          <div className="text-sm">
                            {person.kode_pendaftaran}
                          </div>
                        </td>
                        <td>
                          <div className="text-sm">{person.nama}</div>
                        </td>
                        <td>
                          <div className="text-sm">
                            {
                              this.state.jenis_kelamin_text[
                              person.jenis_kelamin
                              ]
                            }
                          </div>
                        </td>
                        <td>
                          <div className="text-sm">{person.tanggal_lahir}</div>
                        </td>
                        <td>
                          <div className="text-sm">{person.username}</div>
                        </td>
                        <td>
                          <div className="text-sm">{person.email}</div>
                        </td>
                        <td>
                          <div className="text-sm">{person.password}</div>
                        </td>
                        <td>
                          <div className="text-sm">{person.foto_profil}</div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <input
                type="submit"
                className={
                  this.state.simpleLoading || this.state.is_importing
                    ? "btn-disabled px-4 flex items-center rounded-full py-2 mt-2 text-sm"
                    : "btn-schoolmedia px-4 flex items-center rounded-full text-white py-2 mt-2 text-sm"
                }
                value={this.state.is_importing ? "Memproses..." : this.state.simpleLoading ? "Tunggu..." : "Simpan"}
                disabled={this.state.simpleLoading || this.state.is_importing ? true : false}
              />
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn-default mx-1 px-4 py-2 justify-center font-medium rounded-full text-gray-800 items-center text-sm"
              onClick={this.hideModalPrevImport}
              disabled={this.state.is_importing}
            >
              Tutup
            </button>
          </Modal.Footer>
        </Modal>

        {/* Modal Hasil Import */}
        <Modal
          size="lg"
          show={this.state.modal_import_result}
          onHide={this.hideModalImportResult}
        >
          <Modal.Header>
            <h4 className="text-lg font-bold">Hasil Import Data</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="w-full">
              {/* Summary */}
              <div className="grid grid-cols-2 gap-4 mb-4">
                <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                  <div className="flex items-center">
                    <i className="bx bx-check-circle text-3xl text-green-600 mr-3"></i>
                    <div>
                      <p className="text-sm text-gray-600">Berhasil</p>
                      <p className="text-2xl font-bold text-green-600">
                        {this.state.import_success.length}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                  <div className="flex items-center">
                    <i className="bx bx-x-circle text-3xl text-red-600 mr-3"></i>
                    <div>
                      <p className="text-sm text-gray-600">Gagal</p>
                      <p className="text-2xl font-bold text-red-600">
                        {this.state.import_failed.length}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Tabs untuk Success dan Failed */}
              <Tabs defaultActiveKey="success" id="import-result-tabs" className="mb-3">
                <Tab
                  eventKey="success"
                  title={`Berhasil (${this.state.import_success.length})`}
                >
                  <div className="max-h-96 overflow-y-auto">
                    {this.state.import_success.length > 0 ? (
                      <table className="table table-bordered text-sm w-full">
                        <thead className="bg-gray-100 sticky top-0">
                          <tr>
                            <th className="px-3 py-2">No</th>
                            <th className="px-3 py-2">Nama</th>
                            <th className="px-3 py-2">Username</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.import_success.map((item, index) => (
                            <tr key={index} className="hover:bg-gray-50">
                              <td className="px-3 py-2">{index + 1}</td>
                              <td className="px-3 py-2">{item.nama || '-'}</td>
                              <td className="px-3 py-2">{item.username || '-'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div className="text-center py-8 text-gray-500">
                        Tidak ada data yang berhasil diimport
                      </div>
                    )}
                  </div>
                </Tab>
                <Tab
                  eventKey="failed"
                  title={`Gagal (${this.state.import_failed.length})`}
                >
                  <div className="max-h-96 overflow-y-auto">
                    {this.state.import_failed.length > 0 ? (
                      <table className="table table-bordered text-sm w-full">
                        <thead className="bg-gray-100 sticky top-0">
                          <tr>
                            <th className="px-3 py-2">No</th>
                            <th className="px-3 py-2">Nama</th>
                            <th className="px-3 py-2">Username</th>
                            <th className="px-3 py-2">Alasan</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.import_failed.map((item, index) => (
                            <tr key={index} className="hover:bg-gray-50">
                              <td className="px-3 py-2">{index + 1}</td>
                              <td className="px-3 py-2">{item.nama || '-'}</td>
                              <td className="px-3 py-2">{item.username || '-'}</td>
                              <td className="px-3 py-2 text-red-600">
                                {item.reason || 'Terjadi kesalahan'}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div className="text-center py-8 text-gray-500">
                        Semua data berhasil diimport
                      </div>
                    )}
                  </div>
                </Tab>
              </Tabs>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn-schoolmedia px-4 py-2 justify-center font-medium rounded-full text-white items-center text-sm"
              onClick={this.hideModalImportResult}
            >
              Tutup
            </button>
          </Modal.Footer>
        </Modal>

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm mx-auto p-6 mt-4 sm-container">
          {this.state.institusi_id_select !== "" ? (
            <>
              <div className="flex flex-col lg:flex-row lg:items-center gap-4 pb-4">
                {/* Search Input */}
                <div className="relative flex-1">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-400">
                    <i className="bx bx-search text-xl"></i>
                  </span>
                  <input
                    type="search"
                    className="w-full pl-10 pr-4 py-2 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-gray-50/50 text-gray-800 text-sm focus:bg-white focus:outline-none"
                    placeholder="Cari kode pendaftaran, nama, username, token..."
                    id="search"
                    onChange={(event) => {
                      this.setState({ query: event.target.value }, function () {
                        this.dt.loading();
                        this.dt.resetPage(
                          `&query=${this.state.query}&tahun_ajaran=${this.state.tahun_ajaran_search}&paginate=${this.state.mode_show}`
                        );
                      });
                    }}
                  />
                </div>

                {/* Filter and Status Controls */}
                <div className="flex flex-wrap items-center gap-3">
                  {/* Status Dropdown */}
                  <div className="w-52" style={{ minWidth: '180px' }}>
                    <Select
                      styles={selectStyles}
                      className="text-sm"
                      placeholder="Pilih Status"
                      isDisabled={this.state.disabledFilter}
                      defaultValue={
                        this.state.selectStatus !== ""
                          ? {
                              value: this.state.selectStatus,
                              label: this.state.selectStatus,
                            }
                          : null
                      }
                      options={[
                        { value: "Active", label: "Active" },
                        { value: "Pending", label: "Pending" },
                      ]}
                      onChange={(e) => {
                        this.changeStatus(e);
                      }}
                    />
                  </div>

                  {/* Filter Tahun Ajaran Toggle Button */}
                  <button
                    className={`flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-xl border transition-all duration-200 ${
                      this.state.showFilter
                        ? "bg-blue-50 border-blue-200 text-blue-600 shadow-sm"
                        : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50"
                    }`}
                    onClick={() => {
                      this.setState({
                        showFilter: !this.state.showFilter,
                      });
                    }}
                  >
                    <i className="bx bx-filter text-lg"></i>
                    <span>Filter Tahun</span>
                  </button>

                  {/* Total Data Count Badge */}
                  <div className="flex items-center gap-1.5 px-3 py-2 bg-gray-50 border border-gray-150 rounded-xl text-xs font-semibold text-gray-600">
                    <span>Total data:</span>
                    <span className="text-gray-900 bg-gray-200/50 px-2 py-0.5 rounded-md font-bold">
                      {this.state.totalUser != null ? (
                        this.state.totalUser
                      ) : (
                        <i className="bx bx-loader-alt bx-spin"></i>
                      )}
                    </span>
                  </div>
                </div>

                {/* Show limit page buttons */}
                <div className="flex items-center gap-2 lg:ml-auto border-t lg:border-t-0 pt-3 lg:pt-0">
                  <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider mr-1">
                    Tampilkan:
                  </span>
                  <div className="inline-flex rounded-xl p-1 bg-gray-100/80">
                    {[10, 50, 100, 200].map((limit) => (
                      <button
                        key={limit}
                        onClick={this.showMode.bind(this, limit)}
                        className={`px-3 py-1 rounded-lg text-xs font-semibold transition-all duration-200 ${
                          this.state.mode_show === limit
                            ? "bg-white text-blue-600 shadow-sm font-bold"
                            : "text-gray-600 hover:text-gray-900"
                        }`}
                      >
                        {this.state.loading_showmode === limit ? (
                          <div className="w-3 h-3 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                        ) : (
                          limit
                        )}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {/* Dynamic Filter Section */}
              {this.state.showFilter && (
                <div className="flex items-center gap-3 p-4 bg-gray-50 border border-gray-100 rounded-2xl mt-2">
                  <div className="w-64" style={{ minWidth: "180px" }}>
                    <Select
                      id="filterTahunAjaran"
                      styles={selectStyles}
                      isClearable
                      options={this.state.data_tahun_ajaran}
                      onChange={this.filterTahunAjaran}
                      placeholder={"Pilih Tahun Ajaran"}
                    />
                  </div>
                  <button
                    onClick={this.setFilter}
                    className="flex items-center gap-2 px-5 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-all duration-200 shadow-md shadow-blue-500/10 active:scale-95"
                  >
                    <i className="bx bx-search-alt"></i>
                    <span>Terapkan Filter</span>
                  </button>
                </div>
              )}
            </>
          ) : (
            <div className="w-full flex justify-between gap-4 py-2">
              <div className="w-1/2 flex gap-4">
                <Skeleton width={180} height={38} className="rounded-xl" />
                <Skeleton width={120} height={38} className="rounded-xl" />
              </div>
              <div className="w-1/2 flex justify-end gap-4">
                <Skeleton width={180} height={38} className="rounded-xl" />
              </div>
            </div>
          )}

          <div className="mt-4 overflow-hidden border border-gray-100 rounded-2xl bg-gray-50/20 px-2 py-1">
            <DataTable
              ref={(dt) => {
                this.dt = dt;
              }}
              action={{
                nama_rombel: (col, data) => {
                  // CATATAN: Query di UserController (SI) hanya meng-join rombel_siswa
                  // yang is_alumni = false (rombel aktif terakhir). Karena itu field
                  // `is_alumni` yang dikirim ke sini TIDAK PERNAH bernilai true - dia
                  // hanya akan `false` (saat siswa punya rombel aktif) atau `null`
                  // (saat tidak ada rombel aktif sama sekali, join-nya kosong).
                  // Jadi sinyal "tidak ada rombel aktif" yang valid adalah
                  // nama_rombel bernilai null/kosong, BUKAN is_alumni === true.
                  if (col.nama_rombel) {
                    return <p className="text-sm">{col.nama_rombel}</p>;
                  }

                  return (
                    <OverlayTrigger
                      overlay={
                        <Tooltip>
                          Siswa belum memiliki rombel aktif (bisa jadi alumni atau belum pernah ditempatkan)
                        </Tooltip>
                      }
                    >
                      <div className="py-1 w-auto px-2 bg-gray-400 text-white text-xs rounded-full flex items-center justify-center cursor">
                        <i className="bx bx-info-circle text-white font-bold text-sm mr-1"></i>
                        Belum Ada Rombel
                      </div>
                    </OverlayTrigger>
                  );
                },

                jenis_kelamin: (col, data) => {
                  var jekel = "";
                  if (col.jenis_kelamin == 1) {
                    jekel = "Laki - Laki";
                  }

                  if (col.jenis_kelamin == 0) {
                    jekel = "Perempuan";
                  }

                  if (col.jenis_kelamin == null) {
                    jekel = "Belum diketahui";
                  }
                  return <p className="text-sm">{jekel}</p>;
                },

                created_at: (col, data) => {
                  if (col.created_at !== null) {
                    var date = "";
                    var month = "";
                    var year = "";
                    date = col.created_at.substr(8, 2);
                    month = col.created_at.substr(5, 2);
                    year = col.created_at.substr(0, 4);

                    return (
                      <p className="text-sm">
                        {date + "-" + month + "-" + year}
                      </p>
                    );
                  } else {
                    return <p className="text-sm">Tidak Diketahui</p>;
                  }
                },

                status: (col, data) => {
                  var statusUsr = "";
                  var tooltip = "";
                  var warna = "";
                  var ikon = "";
                  var width = "";

                  if (col.status == "Active") {
                    statusUsr = "Aktif";
                    tooltip = "User sudah teraktivasi";
                    warna = "bg-green-600";
                    ikon = "bx-check";
                    width = "w-16";
                  } else if (col.status == "Non-Active") {
                    statusUsr = "Non-Aktif";
                    tooltip = "User telah dinon-aktifkan";
                    warna = "bg-red-600";
                    ikon = "bx-x";
                    width = "w-auto";
                  } else {
                    statusUsr = "Pending";
                    tooltip =
                      "User belum aktivasi di SSO dan klik link konfirmasi di email";
                    warna = "bg-gray-600";
                    ikon = "bx-error";
                    width = "w-20";
                  }
                  return (
                    <OverlayTrigger overlay={<Tooltip>{tooltip}</Tooltip>}>
                      <div
                        className={`py-1 ${width} px-1 ${warna} text-white text-xs rounded-full flex cursor`}
                      >
                        <i
                          className={`bx ${ikon} text-white font-bold text-sm mx-1`}
                        ></i>
                        {statusUsr}
                      </div>
                    </OverlayTrigger>
                  );
                },

                token: (col, data) => {
                  var button = "";
                  var tokenc = "";
                  if (col.token === null) {
                    button = (
                      <div>
                        <div className="text-sm" id={"token" + data.id}></div>
                        <button
                          onClick={this.generate_token.bind(this, data.id)}
                          id={"myButton" + data.id}
                          className="font-medium btn-default text-gray-700 px-4 py-2 mr-1 rounded-full text-sm"
                          disabled={
                            this.state.loading_token === data.id ? true : false
                          }
                        >
                          {this.state.loading_token === data.id ? (
                            <UserButtonLoading color="text-gray-800" />
                          ) : (
                            "Token"
                          )}
                        </button>
                      </div>
                    );
                  } else {
                    button = <div className="text-sm">{col.token}</div>;
                  }
                  return button;
                },

                emaila: (col, data) => {
                  if (data?.email == null || data?.email == "") {
                    var value = "-";
                  } else {
                    var value = data.email;
                  }
                  return (
                    <>
                      <small className="text-small">{value}</small>
                    </>
                  );
                },
                nohpa: (col, data) => {
                  if (data?.no_handphone == null || data?.no_handphone == "") {
                    var value = "-";
                  } else {
                    var value = data.no_handphone;
                  }
                  return (
                    <>
                      <small className="text-small">{value}</small>
                    </>
                  );
                },
                usernamea: (col, data) => {
                  if (data?.username == null || data?.username == "") {
                    var value = "-";
                  } else {
                    var value = data.username;
                  }
                  return (
                    <>
                      <small className="text-small">{value}</small>
                    </>
                  );
                },

                aksi: (col, data) => {
                  return (
                    <div className="text-gray-700 px-4 py-1 flex items-center">
                      <button
                        onClick={this.showModalDetail.bind(this, data.id)}
                        className="btn-blue text-lg text-white py-1 px-2 rounded-full font-medium mr-1"
                      >
                        <i className="bx bxs-user-detail"></i>
                      </button>
                      <button
                        onClick={this.showModalEdit.bind(this, data.id)}
                        className="btn-yellow text-lg text-white py-1 px-2 rounded-full font-medium mr-1"
                      >
                        <i className="bx bxs-edit-alt"></i>
                      </button>
                      <button
                        onClick={() => this.delete(data.id, data.nama || "User Siswa")}
                        className={`${this.state.loading_delete === true
                          ? `btn-gray`
                          : `btn-red`
                          } text-lg text-white py-1 px-2 rounded-full font-medium`}
                        disabled={
                          this.state.loading_delete === true ? true : false
                        }
                      >
                        <i className="bx bx-trash"></i>
                      </button>
                      {this.state.loading_check == false ? (
                        <input
                          type="checkbox"
                          name="check_data[]"
                          id={data.id}
                          value={data.id}
                          onChange={this.selectOne}
                          className="select-checkbox ml-2"
                          defaultChecked={this.state.checkAll}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  );
                },
              }}
              url={this.state.url_table + this.state.institusi_id_select}
              columns={[
                {
                  index: "no_index",
                  label: "No",
                },
                {
                  index: "tahun_ajaran",
                  label: "TH MASUK",
                },
                {
                  index: "tahun_ajaran_sekarang",
                  label: "TH Sekarang",
                },
                {
                  index: "nama_rombel",
                  label: "Rombel",
                },
                {
                  index: "kode_pendaftaran",
                  label: "KODE PENDAFTARAN",
                },
                {
                  index: "nama",
                  label: "NAMA",
                },
                {
                  index: "emaila",
                  label: "EMAIl",
                },
                {
                  index: "nohpa",
                  label: "NO HP"
                },
                {
                  index: "jenis_kelamin",
                  label: "JENIS KELAMIN",
                },
                {
                  index: "tanggal_lahir",
                  label: "TANGGAL LAHIR",
                },
                {
                  index: "status",
                  label: "STATUS",
                },
                {
                  index: "token",
                  label: "TOKEN",
                },
                {
                  index: "aksi",
                  label: "AKSI",
                },
              ]}
            />
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm mx-auto p-4 mt-4 sm-container">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 px-2">
            <div className="flex items-center gap-2 text-gray-500">
              <i className="bx bx-checkbox-checked text-2xl text-blue-500"></i>
              <span className="text-sm font-medium">Tandai beberapa siswa di tabel untuk melakukan aksi massal</span>
            </div>
            
            <div className="flex flex-wrap items-center gap-2 sm:justify-end">
              {this.state.checkAll === false ? (
                <button
                  className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all duration-200 shadow-sm"
                  onClick={this.checkAll}
                >
                  <i className="bx bx-check-square text-lg"></i>
                  <span>Pilih Semua</span>
                </button>
              ) : (
                <button
                  className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-blue-600 bg-blue-50 border border-blue-150 rounded-xl hover:bg-blue-100 transition-all duration-200 shadow-sm"
                  onClick={this.unCheckAll}
                >
                  <i className="bx bx-x-square text-lg"></i>
                  <span>Batal Pilih</span>
                </button>
              )}

              <button
                onClick={this.deleteMulti}
                className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-rose-600 bg-rose-50 border border-rose-100 rounded-xl hover:bg-rose-100 hover:text-rose-700 transition-all duration-200 shadow-sm"
                disabled={this.state.loading_delete}
              >
                {this.state.loading_delete ? (
                  <UserButtonLoading color="text-rose-600" />
                ) : (
                  <>
                    <i className="bx bx-trash text-lg"></i>
                    <span>Hapus</span>
                  </>
                )}
              </button>

              <button
                onClick={this.sendMailActivation}
                className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-blue-600 bg-blue-50 border border-blue-100 rounded-xl hover:bg-blue-100 hover:text-blue-700 transition-all duration-200 shadow-sm"
                disabled={this.state.loading_delete}
              >
                {this.state.loading_mail ? (
                  <UserButtonLoading color="text-blue-600" />
                ) : (
                  <>
                    <i className="bx bx-envelope text-lg"></i>
                    <span>Send Email</span>
                  </>
                )}
              </button>

              <button
                onClick={this.sendWAActivation}
                className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-emerald-600 bg-emerald-50 border border-emerald-100 rounded-xl hover:bg-emerald-100 hover:text-emerald-700 transition-all duration-200 shadow-sm"
                disabled={this.state.loading_delete}
              >
                {this.state.loading_mail ? (
                  <UserButtonLoading color="text-emerald-600" />
                ) : (
                  <>
                    <i className="bx bxl-whatsapp text-lg"></i>
                    <span>Send WA</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Excel Import Wizard */}
        <ExcelImportWizard
          show={this.state.modal_excel_wizard}
          onClose={() => this.setState({ modal_excel_wizard: false })}
          type="SI"
          institusiId={this.state.institusi_id_select}
          title="Import Data Siswa"
          onImportComplete={(result) => {
            // Refresh table on import complete
            this.dt.fetchEntities(
              `&paginate=${this.state.mode_show}&query=${this.state.query}`
            );
            this.showCount();
          }}
        />
      </div>
    );
  }
}